import { apiUrl, sensorsUrl } from "../api/endpoints";
  import React, { useState, useEffect, useContext, useCallback ,useRef, useMemo, Fragment } from 'react';
  import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
  import DeleteDataIcon from '@mui/icons-material/CancelOutlined';
  import TranferIcon from '@mui/icons-material/SyncAltOutlined';
  import RebootIcon from '@mui/icons-material/CachedOutlined';
  import PingIcon from '@mui/icons-material/RefreshOutlined';
  import RenameIcon from '@mui/icons-material/KeyboardOutlined';
  import EditIcon from '@mui/icons-material/Edit';
  import BackIcon from '@mui/icons-material/ArrowBack';
  import { STATIC_ICONS, BUCKET_DEVICES } from '../Constants';
  import { UsersIcons } from '../Icons';
  import './details.css';
  import './DeviceDetails.css';
  import './DownloadReportShared.css';
  import '../Components/modal.css';
  import { useAuth } from '../hooks/AuthProvider';
  import axios from 'axios';
  import CollapseContext from "../hooks/CollapseContext";
  import useWindowDimensions from "../hooks/useWindowDimensions";
  import Tooltip from '@mui/material/Tooltip';
  import WebDashboard from './WebDashboard';
  import Spinner from '../Components/Spinner';
  import DataGridTable from "../Components/DataGridTable";
  import { DownloadReport } from "../Pages/DownloadReport";
  import { capitalize, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
  import { deleteDevice, deleteDeviceData, deviceAction } from '../lib/actions';
  import Select from 'react-select';

  import { DatePicker } from '@mui/x-date-pickers/DatePicker';
  import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
  import dayjs from 'dayjs';
  import { textFieldSlotProps } from './../Style';
  import { LanguageContext } from '../context/LanguageContext';
  import { useAppTheme } from '../context/ThemeContext';
  import devTranslations from '../languages/device.json';
  import DataEvaluationDetails from '../Components/DataEvaluationDetails';
  import { getErrorMessage } from '../utils/errorUtils';
  import DashboardTabsArrow from '../Components/DashboardTabsArrow';
  import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
  import MoreVertIcon from '@mui/icons-material/MoreVert';
  import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
  import OpenInFullIcon from '@mui/icons-material/OpenInFull';
  import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

  import Alert from '../Components/Alert';
  import AppDialog from '../Components/AppDialog'; 
  import { DeleteIcon, DownloadReprtIcon, HistoryIcon, VerticalDividerIcon } from '../svg/UtilsIcons';
import { OrganizationIcon } from '../svg/DeviceIcons';
import { getDeviceLocationId, normalizeLocationListRow, normalizeOrganizationListRow, normalizeUserListRow } from '../utils/listRowIds';
import { DividerMenuIcon, MenuBackButtonIcon } from '../svg/TemplateIcons';
import { AssetCardMainIcon } from '../svg/AssetCardIcon';
import WorkDaysHoursPicker, { normalizeWorkDaysHours } from '../Components/WorkDaysHoursPicker';
import { getThemeColorValue, normalizeThemeMode } from '../utils/themeColors';
import { DEFAULT_ASSET_CARD_CONFIG, getAssetCardDeviceDetailsFieldOptions, normalizeAssetCardConfig, normalizeStringList } from '../utils/assetCardConfig';
import {
  aggregatePeriodColumnSeries,
  getPeriodColumnQueryRange,
  isNotFoundApiError,
  PERIOD_COLUMN_WIDGET_TYPE,
  normalizePeriodColumnPeriod,
  normalizePeriodColumnStat,
  resolvePeriodColumnWidgetBinding,
} from '../utils/periodColumnWidget';
import { normalizeDeviceChartResponse, normalizeDeviceLivePayload } from '../utils/deviceChartData';
import { buildChartSamplingPayload } from '../utils/chartSampling';
import { normalizeWidgetAggregation } from '../utils/chartAggregation';
import { clearActiveAiDeviceId, setActiveAiDeviceId } from '../utils/aiDeviceContext';

  const isDeviceOnlineStatus = (status) =>
    String(status || "").trim().toLowerCase() === "online";

  const resolveDeviceTemplateImageUrl = (value) => {
    const normalized = String(value || "").trim().replace(/\\/g, "/");
    if (!normalized) return "";
    if (/^(?:blob:|data:|https?:\/\/)/i.test(normalized)) return normalized;

    const relativePath = normalized
      .replace(/^\/+/, "")
      .replace(/^(?:static\/files\/)?icons\//i, "");
    return `${STATIC_ICONS}${relativePath}`;
  };

  const DeviceDetailsHeroImage = ({ templateImage, deviceIcon }) => {
    const templateSrc = resolveDeviceTemplateImageUrl(templateImage);
    const deviceSrc = resolveDeviceTemplateImageUrl(deviceIcon);
    const [templateFailed, setTemplateFailed] = useState(false);
    const [deviceFailed, setDeviceFailed] = useState(false);

    useEffect(() => {
      setTemplateFailed(false);
    }, [templateSrc]);

    useEffect(() => {
      setDeviceFailed(false);
    }, [deviceSrc]);

    const src = templateSrc && !templateFailed
      ? templateSrc
      : (deviceSrc && !deviceFailed ? deviceSrc : "");

    if (!src) {
      return (
        <div className="details-device-icon details-device-icon--svg asset-hero-icon" aria-label="icon">
          <AssetCardMainIcon />
        </div>
      );
    }

    const showingTemplate = src === templateSrc && !templateFailed;

    return (
      <img
        alt=""
        src={src}
        className="details-device-icon"
        decoding="async"
        onError={() => {
          if (showingTemplate) {
            setTemplateFailed(true);
          } else {
            setDeviceFailed(true);
          }
        }}
      />
    );
  };

  const pagingoptions = [10, 20, 50, 100];
  const PERIOD_COLUMN_INFLUX_REFRESH_MS = 30000;
  const emptyTemplateState = {
      id: 0,
      tid: '',
      name: '',
      device_count: 0,
      datastreams: null,
      webdashboard: null,
      mobdashboard: null,
      events: null,
      icon: null,
      templateEvaluationData: null
  };

  const checkTabPermission = (userRole, allowedRoles) => {
      const role = userRole?.toLowerCase();

      if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
          return false;
      }

      return allowedRoles.map(r => r.toLowerCase()).includes(role);
  };


  export const EditDeviceId = ({ state, setState, refresh, onUpdated }) => {
    const { permissions } = useAuth();
    const { lang } = useContext(LanguageContext);

    const canEditDevices = permissions["edit_devices"];
    const canViewLocations = permissions["view_locations"];
    const tRoot = devTranslations[lang] || devTranslations.en;
    const tDid = tRoot.editDeviceId;
    const tAdd = tRoot.addDevice;
    const tRename = tRoot.renameDevice;
    const isRtl = ["ar", "ur"].includes(lang);

    const [formData, setFormData] = useState({
      name: "",
      did: "",
      locationId: null,
      work_days_hours: [],
    });
    const initialDataRef = useRef({
      name: "",
      did: "",
      locationId: null,
      work_days_hours: [],
    });
    const [loadingDevice, setLoadingDevice] = useState(false);
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [locations, setLocations] = useState([]);

    const [alertState, setAlertState] = useState({
      open: false,
      message: "",
      type: "info",
      position: isRtl ? "left" : "right",
    });

    const showAlert = useCallback(
      (type, message) => {
        setAlertState({ open: true, type, message, position: isRtl ? "left" : "right" });
      },
      [isRtl]
    );

    const closeModal = () => setState({ open: false, id: 0, row: null });

    const buildEditFormState = useCallback((device = {}) => {
      const locationId = getDeviceLocationId(device);

      return {
        name: String(device?.name || ""),
        did: String((device?._did ?? device?.did) || ""),
        locationId: locationId ? Number(locationId) : null,
        work_days_hours: normalizeWorkDaysHours(device?.work_days_hours || []),
      };
    }, []);

    const hasOwnField = useCallback(
      (row, key) => Boolean(row) && Object.prototype.hasOwnProperty.call(row, key),
      []
    );

    const hasCompleteEditSeed = useCallback(
      (row) =>
        Boolean(row) &&
        hasOwnField(row, "name") &&
        (hasOwnField(row, "did") || hasOwnField(row, "_did")) &&
        (hasOwnField(row, "location_id") || hasOwnField(row, "_location_id")) &&
        hasOwnField(row, "work_days_hours"),
      [hasOwnField]
    );

    useEffect(() => {
      if (!state?.open) return;

      const row = state?.row || {};
      const nextData = buildEditFormState(row);

      setFormData(nextData);
      initialDataRef.current = nextData;
      setLoadingDevice(false);
    }, [buildEditFormState, state?.open, state?.row]);

    useEffect(() => {
      if (!state?.open || !state?.id) return;
      const row = state?.row || null;
      if (hasCompleteEditSeed(row)) return;

      let mounted = true;
      const fetchDeviceDetails = async () => {
        setLoadingDevice(true);
        try {
          const res = await axios.get(apiUrl(`device/get/${state.id}`));
          const device = res?.data?.data || {};
          if (!mounted) return;
          const nextData = buildEditFormState(device);
          setFormData(nextData);
          initialDataRef.current = nextData;
        } catch (error) {
          if (mounted) {
            showAlert("error", getErrorMessage(error));
          }
        } finally {
          if (mounted) {
            setLoadingDevice(false);
          }
        }
      };

      fetchDeviceDetails();
      return () => {
        mounted = false;
      };
    }, [buildEditFormState, hasCompleteEditSeed, showAlert, state?.id, state?.open, state?.row]);

    useEffect(() => {
      if (!state?.open || !canViewLocations) {
        setLocations([]);
        return;
      }

      let mounted = true;
      const fetchLocations = async () => {
        setLoadingLocations(true);
        try {
          const res = await axios.get(apiUrl(`location`));
          if (!mounted) return;
          const list = Array.isArray(res?.data?.data)
            ? res.data.data.map(normalizeLocationListRow)
            : [];
          setLocations(list);
        } catch (error) {
          if (mounted) {
            showAlert("error", getErrorMessage(error));
            setLocations([]);
          }
        } finally {
          if (mounted) {
            setLoadingLocations(false);
          }
        }
      };

      fetchLocations();

      return () => {
        mounted = false;
      };
    }, [canViewLocations, showAlert, state?.open]);

    const editDevice = async () => {
      if (submitting) return;

      const normalizedName = String(formData.name || "").trim();
      const normalizedDid = String(formData.did || "").replace(/\s+/g, "").trim();
      const normalizedLocationId = formData.locationId ? Number(formData.locationId) : null;

      if (!normalizedName) {
        showAlert("error", tRename.renameError);
        return;
      }

      if (!normalizedDid) {
        showAlert("error", tDid.requiredError);
        return;
      }

      const initialName = String(initialDataRef.current.name || "").trim();
      const initialDid = String(initialDataRef.current.did || "").replace(/\s+/g, "").trim();
      const initialLocationId = initialDataRef.current.locationId ? Number(initialDataRef.current.locationId) : null;

      const didChanged = normalizedDid !== initialDid;
      const detailsChanged =
        normalizedName !== initialName ||
        normalizedLocationId !== initialLocationId ||
        JSON.stringify(normalizeWorkDaysHours(formData.work_days_hours)) !==
          JSON.stringify(normalizeWorkDaysHours(initialDataRef.current.work_days_hours));

      if (!didChanged && !detailsChanged) {
        showAlert("info", tDid.validation.noChanges);
        return;
      }

      setSubmitting(true);
      try {
        let updatedPayload = {};
        if (detailsChanged) {
          const updateRes = await axios.post(
            apiUrl(`device/update/${state.id}`),
            {
              name: normalizedName,
              location_id: normalizedLocationId,
              work_days_hours: normalizeWorkDaysHours(formData.work_days_hours),
            },
            { headers: { "Content-Type": "application/json" } }
          );
          updatedPayload = updateRes?.data?.data || {};
        }

        if (didChanged) {
          await axios.post(
            apiUrl(`device/edit-did`),
            { id: state.id, newDid: normalizedDid },
            { headers: { "Content-Type": "application/json" } }
          );
        }

        onUpdated?.({
          ...updatedPayload,
          name: normalizedName,
          did: normalizedDid,
          location_id: normalizedLocationId,
          work_days_hours: normalizeWorkDaysHours(formData.work_days_hours),
        });

        showAlert("success", tDid.successMessage);
        refresh?.();
        setTimeout(() => closeModal(), 1200);
      } catch (error) {
        showAlert("error", getErrorMessage(error));
        setSubmitting(false);
      }
    };

    if (!state?.open) return null;

    const locationOptions = locations.map((location) => ({
      value: location.id,
      label: location.address
        ? `${location.name || tAdd.locationOptionFallback} (${location.address})`
        : (location.name || tAdd.locationOptionFallbackWithId.replace('{id}', location.id)),
      ...location,
    }));
    const selectedLocationOption =
      locationOptions.find((option) => Number(option.value) === Number(formData.locationId)) || null;

    if (!canEditDevices) {
      return (
        <div id="modal" dir={isRtl ? "rtl" : "ltr"}>
          <Alert
            open={alertState.open}
            close={() => setAlertState((s) => ({ ...s, open: false }))}
            message={alertState.message}
            type={alertState.type}
            position={alertState.position}
          />

          <div id="popup" className="dashboard-modal">
            <div className="dashboard-header">
              <div className="dashboard-header-text">
                <h2>{tDid.permissionDenied.title}</h2>
                <p>{tDid.permissionDenied.message}</p>
              </div>
            </div>

            <div className="modal-divider" />

            <div className="modal-content dashboard-content" />

            <div className="modal-footer dashboard-footer">
              <div />
              <div className="modal-footer-right-buttons">
                <button className="btn btn-cancel" onClick={closeModal}>
                  {tDid.buttonClose}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div id="modal" dir={isRtl ? "rtl" : "ltr"}>
        <Alert
          open={alertState.open}
          close={() => setAlertState((s) => ({ ...s, open: false }))}
          message={alertState.message}
          type={alertState.type}
          position={alertState.position}
        />

        <div id="popup" className="dashboard-modal">
          <div className="dashboard-header">
            <div className="dashboard-header-text">
              <h2>{tRoot.deviceDetails.editDevice}</h2>
              <p>{tDid.description}</p>
            </div>
          </div>

          <div className="modal-divider" />

          <div className="modal-content dashboard-content">
            {loadingDevice ? (
              <Spinner />
            ) : (
              <div className="form-section">
                <div className="form-item">
                  <label className="form-lbl">{tRename.label}</label>
                  <input
                    type="text"
                    className="add-column"
                    placeholder={tRename.placeholder}
                    value={formData.name}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, name: e.target.value }))
                    }
                    maxLength={50}
                  />
                </div>

                <div className="form-item">
                  <label className="form-lbl">{tDid.label}</label>
                  <div className="dd-relative">
                    <input
                      type="text"
                      className="add-column dd-input-counter"
                      placeholder={tDid.placeholder}
                      value={formData.did}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          did: e.target.value.replace(/\s/g, ""),
                        }))
                      }
                      maxLength={50}
                    />
                    <span className="form-helper dd-input-counter-text">
                      {formData.did.length} / 50
                    </span>
                  </div>
                  {tDid.helper ? <span className="form-name-helper">{tDid.helper}</span> : null}
                </div>

                {canViewLocations ? (
                  <div className="form-item">
                    <label className="form-lbl">{tAdd.labelLocation}</label>
                    <Select
                      id="device-location-select"
                      options={locationOptions}
                      value={selectedLocationOption}
                      onChange={(selectedOption) =>
                        setFormData((prev) => ({
                          ...prev,
                          locationId: selectedOption ? selectedOption.value : null,
                        }))
                      }
                      isClearable
                      isDisabled={loadingLocations}
                      placeholder={loadingLocations ? tAdd.placeholderLocationLoading : tAdd.placeholderLocation}
                      noOptionsMessage={() => tAdd.noLocations}
                      classNamePrefix="react-select"
                    />
                  </div>
                ) : null}

                <div className="form-item">
                  <WorkDaysHoursPicker
                    value={formData.work_days_hours}
                    onChange={(nextRows) =>
                      setFormData((prev) => ({ ...prev, work_days_hours: nextRows }))
                    }
                    labels={{
                      title: tAdd.workDaysHoursTitle || 'Work days and hours',
                      sameShift:
                        tAdd.sameShift ||
                        'Use same shift start / shift end for all work days',
                    }}
                  />
                </div>

              </div>
            )}
          </div>

          <div className="modal-footer dashboard-footer">
            <div />
            <div className="modal-footer-right-buttons">
              <button className="btn btn-cancel" onClick={closeModal} disabled={submitting}>
                {tAdd.buttonCancel}
              </button>
              <button className="btn btn-apply" onClick={editDevice} disabled={submitting || loadingDevice}>
                {tDid.buttonSave}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };


  export const RenameDevice = ({ state, setState, refresh }) => {
    const { permissions } = useAuth();
    const { lang } = useContext(LanguageContext);

    const canRenameDevices = permissions["rename_devices"];
    const tRoot = devTranslations[lang] || devTranslations.en;
    const t = tRoot.renameDevice;
    const isRtl = ["ar", "ur"].includes(lang);

    const [newName, setNewName] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const [alertState, setAlertState] = useState({
      open: false,
      message: "",
      type: "info",
      position: isRtl ? "left" : "right",
    });

    const showAlert = useCallback(
      (type, message) => {
        setAlertState({ open: true, type, message, position: isRtl ? "left" : "right" });
      },
      [isRtl]
    );

    const closeModal = () => {
      setSubmitting(false);
      setState({ open: false, id: 0 });
    };

    const renameDevice = async () => {
      if (submitting) return;

      if (!newName || newName.trim() === "") {
        showAlert("error", t.renameError);
        return;
      }

      setSubmitting(true);
      try {
        const res = await axios.post(
          apiUrl(`device/update/${state.id}`),
          { name: newName },
          { headers: { "Content-Type": "application/json" } }
        );

        showAlert("success", res.data?.message || t.renameSuccess);
        refresh?.();

        setTimeout(() => closeModal(), 1500);
      } catch (error) {
        showAlert("error", getErrorMessage(error));
        setSubmitting(false);
      }
    };

    if (!state?.open) return null;

    if (!canRenameDevices) {
      return (
        <div id="modal" dir={isRtl ? "rtl" : "ltr"}>
          <Alert
            open={alertState.open}
            close={() => setAlertState((s) => ({ ...s, open: false }))}
            message={alertState.message}
            type={alertState.type}
            position={alertState.position}
          />

          <div id="popup" className="dashboard-modal">
            <div className="dashboard-header">
              <div className="dashboard-header-text">
                <h2>{t.permissionDenied.title}</h2>
                <p>{t.permissionDenied.message}</p>
              </div>
            </div>

            <div className="modal-divider" />
            <div className="modal-content dashboard-content" />

            <div className="modal-footer dashboard-footer">
              <div />
              <div className="modal-footer-right-buttons">
                <button className="btn btn-cancel" onClick={closeModal}>
                  {t.buttonClose}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div id="modal" dir={isRtl ? "rtl" : "ltr"}>
        <Alert
          open={alertState.open}
          close={() => setAlertState((s) => ({ ...s, open: false }))}
          message={alertState.message}
          type={alertState.type}
          position={alertState.position}
        />

        <div id="popup" className="dashboard-modal">
          <div className="dashboard-header">
            <div className="dashboard-header-text">
              <h2>{t.title}</h2>
              <p>{t.description || ""}</p>
            </div>
          </div>

          <div className="modal-divider" />

          <div className="modal-content dashboard-content">
            <div className="form-section">
              <div className="form-item">
                <label className="form-lbl">{t.label}</label>

                <div className="dd-relative">
                  <input
                    type="text"
                    className="add-column dd-input-counter"
                    placeholder={t.placeholder}
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    maxLength={50}
                  />

                  <span className="form-helper dd-input-counter-text">
                    {newName.length} / 50
                  </span>
                </div>

                {t.helper ? <span className="form-name-helper">{t.helper}</span> : null}
              </div>
            </div>
          </div>

          <div className="modal-footer dashboard-footer">
            <div />
            <div className="modal-footer-right-buttons">
                <button className="btn btn-cancel" onClick={closeModal} disabled={submitting}>
                {tRoot.addDevice.buttonCancel}
              </button>
              <button className="btn btn-apply" onClick={renameDevice} disabled={submitting}>
                {t.button}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export const TransferDevice = ({ state, setState, refresh }) => {
    const { permissions } = useAuth();
    const canTransferDevices = permissions["transfer_devices"];
    const { lang } = useContext(LanguageContext);
    const tRoot = devTranslations[lang] || devTranslations.en;
    const t = tRoot.transferDevice;
    const isRtl = ["ar", "ur"].includes(lang);

    const [continued, setContinued] = useState(false);
    const [transferBy, setTransferBy] = useState(false); // false=user, true=org
    const [users, setUsers] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [newOwner, setNewOwner] = useState(null);
    const [newOrganization, setNewOrganization] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const [alertState, setAlertState] = useState({
      open: false,
      message: "",
      type: "info",
      position: isRtl ? "left" : "right",
    });

    const showAlert = useCallback(
      (type, message) => {
        setAlertState({ open: true, type, message, position: isRtl ? "left" : "right" });
      },
      [isRtl]
    );

    const closeModal = () => {
      setContinued(false);
      setTransferBy(false);
      setNewOwner(null);
      setNewOrganization(null);
      setSubmitting(false);
      setState({ open: false, id: 0 });
    };

    useEffect(() => {
      if (!canTransferDevices || !state?.open) return;

      const fetchInitialData = async () => {
        try {
          const [userResponse, organizationResponse] = await Promise.all([
            axios.get(apiUrl(`user/list`)),
            axios.get(apiUrl(`organization/list`)),
          ]);

          if (userResponse.data?.status === "OK" && Array.isArray(userResponse.data.data)) {
            setUsers(userResponse.data.data.map(normalizeUserListRow));
          } else {
            setUsers([]);
            showAlert("error", t.invalidUserData);
          }

          if (organizationResponse.data?.status === "OK" && Array.isArray(organizationResponse.data.data)) {
            setOrganizations(organizationResponse.data.data.map(normalizeOrganizationListRow));
          } else {
            setOrganizations([]);
            showAlert("error", t.invalidOrganizationData);
          }
        } catch (err) {
          setUsers([]);
          setOrganizations([]);
          showAlert("error", `${t.loadPageDataError} ${getErrorMessage(err)}`);
        }
      };

      fetchInitialData();
    }, [canTransferDevices, showAlert, state?.open, t.invalidOrganizationData, t.invalidUserData, t.loadPageDataError]);

    const transferDevice = async () => {
      if (submitting) return;

      if (transferBy === true && !newOrganization?.value) {
        showAlert("error", t.transferOrgError);
        return;
      }
      if (transferBy === false && !newOwner?.value) {
        showAlert("error", t.transferOwnerError);
        return;
      }

      const endpoint = transferBy ? "organization-transfer" : "user-transfer";

      const body = transferBy
        ? { organization_id: newOrganization.value }
        : { owner_id: newOwner.value };

      setSubmitting(true);
      try {
        const res = await axios.post(apiUrl(`device/${endpoint}/${state.id}`), body, {
          headers: { "Content-Type": "application/json" },
        });

        showAlert("success", res.data?.message || t.transferSuccess);
        refresh?.();

        setTimeout(() => closeModal(), 1500);
      } catch (err) {
        showAlert("error", getErrorMessage(err));
        setSubmitting(false);
      }
    };

    if (!state?.open) return null;

    if (!canTransferDevices) {
      return (
        <div id="modal" dir={isRtl ? "rtl" : "ltr"}>
          <Alert
            open={alertState.open}
            close={() => setAlertState((s) => ({ ...s, open: false }))}
            message={alertState.message}
            type={alertState.type}
            position={alertState.position}
          />

          <div id="popup" className="dashboard-modal">
            <div className="dashboard-header">
              <div className="dashboard-header-text">
                <h2>{t.permissionDenied.title}</h2>
                <p>{t.permissionDenied.message}</p>
              </div>
            </div>

            <div className="modal-divider" />
            <div className="modal-content dashboard-content" />

            <div className="modal-footer dashboard-footer">
              <div />
              <div className="modal-footer-right-buttons">
                <button className="btn btn-cancel" onClick={closeModal}>
                  {t.buttonClose}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    const userOptions = users.map((u) => ({ value: u.id, label: u.name }));
    const organizationOptions = organizations.map((o) => ({ value: o.id, label: o.name }));

    const onRadioChange = (_e, value) => {
      setNewOwner(null);
      setNewOrganization(null);
      setTransferBy(value === "true");
    };

    return (
      <div id="modal" dir={isRtl ? "rtl" : "ltr"}>
        <Alert
          open={alertState.open}
          close={() => setAlertState((s) => ({ ...s, open: false }))}
          message={alertState.message}
          type={alertState.type}
          position={alertState.position}
        />

        <div id="popup" className={`dashboard-modal ${continued ? "tall" : ""}`}>
          <div className="dashboard-header">
            <div className="dashboard-header-text">
              <h2>{t.title}</h2>
              <p>{continued ? (transferBy ? t.descOrg : t.descUser) : t.description}</p>
            </div>
          </div>

          <div className="modal-divider" />

          <div className="modal-content dashboard-content">
            {continued ? (
              <div className="form-section">
                <div className="form-item">
                  <label className="form-lbl">{transferBy ? t.inputOrg : t.inputUser}</label>

                  {transferBy ? (
                    <Select
                      id="organization-select"
                      options={organizationOptions}
                      value={newOrganization}
                      onChange={(opt) => setNewOrganization(opt)}
                      isClearable
                      placeholder={t.selectOrgPlaceholder}
                      classNamePrefix="react-select"
                    />
                  ) : (
                    <Select
                      id="owner-select"
                      options={userOptions}
                      value={newOwner}
                      onChange={(opt) => setNewOwner(opt)}
                      isClearable
                      placeholder={t.selectUserPlaceholder}
                      classNamePrefix="react-select"
                    />
                  )}
                </div>
              </div>
            ) : (
              <div className="form-section">
                <RadioGroup value={transferBy ? "true" : "false"} onChange={onRadioChange}>
                  <FormControlLabel value="false" label={t.optionUser} control={<Radio />} />
                  <Typography className="dd-transfer-desc">
                    {t.descUser}
                  </Typography>

                  <FormControlLabel value="true" label={t.optionOrg} control={<Radio />} />
                  <Typography className="dd-transfer-desc">
                    {t.descOrg}
                  </Typography>
                </RadioGroup>
              </div>
            )}
          </div>

          <div className="modal-footer dashboard-footer">
            <div className="dd-footer-left">
              {continued ? (
                <button className="btn btn-cancel" onClick={() => setContinued(false)} disabled={submitting}>
                  <BackIcon className="dd-back-icon" />
                  {t.buttonBack}
                </button>
              ) : (
                <div />
              )}
            </div>

            <div className="modal-footer-right-buttons">
              <button className="btn btn-cancel" onClick={closeModal} disabled={submitting}>
                {t.buttonCancel}
              </button>

              <button className="btn btn-apply" onClick={continued ? transferDevice : () => setContinued(true)} disabled={submitting}>
                {continued ? t.buttonTransfer : t.buttonContinue}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };


  const DeviceEvents = ({ close, templateId, deviceId, range, tstop }) => {
    const { permissions } = useAuth();
    const { lang } = useContext(LanguageContext);

    const canViewDeviceEvents = permissions["view_device_events"];

    const t = devTranslations?.[lang]?.eventsModal || {};
    const isRtl = ["ar", "ur"].includes(lang);

    const [data, setData] = useState({ rows: [], columns: [], loading: true });
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [rowCount, setRowCount] = useState(0);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    const [alertState, setAlertState] = useState({
      open: false,
      message: "",
      type: "info",
      position: isRtl ? "left" : "right",
    });

    const showAlert = (type, message) => {
      setAlertState({ open: true, type, message, position: isRtl ? "left" : "right" });
    };

    const fetchData = useCallback(async () => {
      if (!canViewDeviceEvents || !templateId || !deviceId) {
        setData({ columns: [], rows: [], loading: false });
        return;
      }

      setData((prev) => ({ ...prev, loading: true }));

      try {
        const sort = sortModel?.[0] || {};
        const params = new URLSearchParams({
          bucket: "Sensors",
          measurement: templateId,
          device: deviceId,
          tstart: tstop - range,
          tstop: tstop,
          page,
          pageSize,
          sortField: sort.field || "_time",
          sortOrder: sort.sort || "desc",
          filterModel: JSON.stringify(filterModel || { items: [] }),
        });

        const res = await axios.get(apiUrl(`data/query_events?${params.toString()}`));
        const eventData = res?.data?.data;

        if (Array.isArray(eventData)) {
          setData({
            columns: eventData[0]
              ? [
                  { field: "id", headerName: "Id", width: 90, align: "left", headerAlign: "left" },
                  ...Object.keys(eventData[0]).map((key) => ({
                    field: key,
                    headerName: capitalize(key),
                    width: 150,
                    align: "left",
                    headerAlign: "left",
                  })),
                ]
              : [],
            rows: eventData.length > 0 ? eventData.map((row, idx) => ({ id: idx, ...row })) : [],
            loading: false,
          });
          setRowCount(Number(res?.data?.pagination?.total ?? eventData.length));
        } else {
          throw new Error("Received an invalid data format from the server.");
        }
      } catch (err) {
        const errorMessage = getErrorMessage(err);
        showAlert("error", `Failed to load events: ${errorMessage}`);
        setData({ columns: [], rows: [], loading: false });
        setRowCount(0);
      }
    }, [canViewDeviceEvents, deviceId, filterModel, page, pageSize, range, sortModel, templateId, tstop]);

    useEffect(() => {
      fetchData();
    }, [fetchData]);

    if (!canViewDeviceEvents) {
      return null;
    }

    return (
      <Fragment>
        <div id="modal" onClick={close}>
          <Alert
            open={alertState.open}
            close={() => setAlertState({ ...alertState, open: false })}
            message={alertState.message}
            type={alertState.type}
            position={alertState.position}
          />

          <div
            id="popup"
            className={`dashboard-modal device-events-modal ${isRtl ? "rtl" : ""}`}
            onClick={(e) => e.stopPropagation()}
            dir={isRtl ? "rtl" : "ltr"}
          >
            <div className="dashboard-header">
              <div className="dashboard-header-text">
                <h2>{t.title || "Device Events"}</h2>
                <p>
                  {t.subTitle ||
                    "You are in a "}
                  <strong>{t.viewMode || "View"}</strong>
                  {t.subTitle2 || " mode. Events are read-only."}
                </p>
              </div>
            </div>

            <div className="modal-divider" />

            <div className="modal-content">
              <div className="dashboard-content device-events-content">
                <div className="modal-info device-events-info-banner">
                  <div className="device-events-info-icon">i</div>
                  <div className="device-events-info-text">
                    <h4>{t.summaryTitle || "Events"}</h4>
                    <p>{t.summaryDesc || "Showing events for the selected time range."}</p>
                  </div>
                </div>

                <div className="device-events-table-area">
                  {data.loading && data.rows.length === 0 && rowCount === 0 && !(filterModel?.items || []).length ? (
                    <Spinner />
                  ) : data.rows.length > 0 || rowCount > 0 || (filterModel?.items || []).length > 0 ? (
                    <div className="table-wrapper device-events-table-wrapper">
                      <DataGridTable
                        columns={data.columns}
                        rows={data.rows}
                        size={300}
                        idcolumn={"id"}
                        pagingoptions={pagingoptions}
                        checkboxSelection
                        showToolbar
                        tableKey="deviceDetails"
                        loading={data.loading}
                        pagination={{
                          serverSide: true,
                          page,
                          pageSize,
                          count: rowCount,
                          sortModel,
                          onPageChange: setPage,
                          onPageSizeChange: (newSize) => {
                            setPageSize(newSize);
                            setPage(1);
                          },
                          onSortModelChange: (newModel) => {
                            setSortModel(newModel && newModel.length ? newModel : []);
                            setPage(1);
                          },
                          onFilterModelChange: (newModel) => {
                            setFilterModel(newModel || { items: [] });
                            setPage(1);
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <div className="device-events-empty">{t.noData || "No data"}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer device-events-footer">
              <button className="btn btn-cancel" onClick={close}>
                {devTranslations?.[lang]?.addDevice?.buttonCancel || "Close"}
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };



  export const DeviceDetails = () => {
      const { id } = useParams();
      const navigate = useNavigate();
      const location = useLocation();
      const [searchParams, setSearchParams] = useSearchParams();
      const { lang } = useContext(LanguageContext);
      const { mode } = useAppTheme();
      const themeMode = normalizeThemeMode(mode);
      const L = devTranslations[lang].deviceDetails;
      const isRtl = ['ar', 'ur'].includes(lang);
      const [worstStatus, setWorstStatus] = useState(null);
      const [latestStreamData, setLatestStreamData] = useState(null);
      const [details, setDetails] = useState({
          data: null,
          loading: true
      });

      useEffect(() => {
          // Route changes can happen before the next device payload arrives. Clear the
          // previous AI device scope immediately so no request can leak the old DID.
          clearActiveAiDeviceId();
      }, [id]);

      useEffect(() => {
          const deviceDid = String(details.data?.did ?? '').trim();
          if (deviceDid) {
              setActiveAiDeviceId(deviceDid);
          } else {
              clearActiveAiDeviceId();
          }

          return () => {
              clearActiveAiDeviceId(deviceDid);
          };
      }, [details.data?.did]);
      const [isDisabledBlocked, setIsDisabledBlocked] = useState(false);
      const [template, setTemplate] = useState(emptyTemplateState);
      const { user, permissions } = useAuth();
      const userRole = user?.role?.toLowerCase(); 
      const dims = useWindowDimensions();
      const initialTab = parseInt(searchParams.get('tab')) || 0;
      const [currentDashboard, setCurrentDashboard] = useState(initialTab);
      const [currentRange, setCurrentRange] = useState(0);
      const [customFrom, setCustomFrom] = useState(null);
      const [customTo, setCustomTo] = useState(null);
      const [customDraftFrom, setCustomDraftFrom] = useState(null);
      const [customDraftTo, setCustomDraftTo] = useState(null);
      const [isCustomActive, setIsCustomActive] = useState(false);
      const [customPopoverOpen, setCustomPopoverOpen] = useState(false);
      const [customPopoverPos, setCustomPopoverPos] = useState({ top: 0, left: 0 });
      const [deviceAssetCards, setDeviceAssetCards] = useState([]);
      const [assetCardSummaryLimit, setAssetCardSummaryLimit] = useState(DEFAULT_ASSET_CARD_CONFIG.deviceDetailsMaxItems);
      const [assetCardSummaryFields, setAssetCardSummaryFields] = useState([]);
      const [rename, setRename] = useState({
          open: false,
          id: 0
      });
      const [editDid, setEditDid] = useState({
          open: false,
          id: 0,
          row: null
      });
      const [report, setReport] = useState({
          open: false,
          id: 0,
          device: undefined
      });
      const [loadingReport, setLoadingReport] = useState(false);

      const [transfer, setTransfer] = useState({
          open: false,
          id: 0
      });
      const [deviceEvents, setDeviceEvents] = useState(false);
      const [showStatusModal, setShowStatusModal] = useState({ open: false });
      const [isDashboardExpanded, setIsDashboardExpanded] = useState(false);
      const [dashboardViewportHeight, setDashboardViewportHeight] = useState(null);

      const [moreMenuOpen, setMoreMenuOpen] = useState(false);
      const moreMenuRef = useRef(null);

      const customPopoverRef = useRef(null);
      const customBtnRef = useRef(null);
      const previousSidenavOpenRef = useRef(false);
      const wasDashboardExpandedRef = useRef(false);
      const dashboardBodyRef = useRef(null);
      const dashboardViewportRef = useRef(null);

      const updateCustomPopoverPosition = useCallback(() => {
          const btn = customBtnRef.current;
          if (!btn) return;
          const rect = btn.getBoundingClientRect();

          const viewportPadding = 12;
          const popoverWidth = 520;
          let left = isRtl ? rect.left : rect.right - popoverWidth;
          const maxLeft = window.innerWidth - viewportPadding - popoverWidth;
          const minLeft = viewportPadding;
          left = Math.max(minLeft, Math.min(left, maxLeft));

          const top = rect.bottom + 12;
          setCustomPopoverPos({ top, left });
      }, [isRtl]);

      useEffect(() => {
          if (!customPopoverOpen) return;

          updateCustomPopoverPosition();

          const onScroll = () => updateCustomPopoverPosition();
          const onResize = () => updateCustomPopoverPosition();

          window.addEventListener('scroll', onScroll, true);
          window.addEventListener('resize', onResize);

          return () => {
              window.removeEventListener('scroll', onScroll, true);
              window.removeEventListener('resize', onResize);
          };
      }, [customPopoverOpen, updateCustomPopoverPosition]);



      const [alertState, setAlertState] = useState({
          open: false,
          message: '',
          type: 'info',
          position: isRtl ? 'left' : 'right'
      });

      const showAlert = useCallback((type, message) => {
          setAlertState({ open: true, type, message, position: isRtl ? 'left' : 'right' });
      }, [isRtl]);
      const disabledAccessMessage =
          L.deviceDisabledBlocked || 'This device is disabled. Access to device details is blocked.';
      const isDisabledForCurrentUser =
          String(details?.data?.plan_status || '').toLowerCase() === 'disabled';
      const isDeviceAccessBlocked = isDisabledBlocked || isDisabledForCurrentUser;
      const clearDeviceViewState = useCallback(() => {
          setTemplate(emptyTemplateState);
          setLatestStreamData(null);
          setWorstStatus(null);
          setMoreMenuOpen(false);
          setDeviceAssetCards([]);
      }, []);
      const blockDisabledDeviceAccess = useCallback((message) => {
          setIsDisabledBlocked(true);
          setDetails({ data: null, loading: false });
          clearDeviceViewState();
          showAlert('warning', message || disabledAccessMessage);
      }, [clearDeviceViewState, disabledAccessMessage, showAlert]);
  const allDataRef = useRef({});
  const resolverRef = useRef(null);
  const [dialog, setDialog] = useState({  
      open: false,
      type: "alert", // "alert" | "confirm"
      variant: "info", // "info" | "danger" | "error"
      icon: "alert", // "alert" | "delete"
      title: "",
      message: "",
      confirmText: "Ok",
      cancelText: "Cancel",
      showCancel: false,
  });

  const closeDialog = useCallback((result = false) => {
      setDialog((d) => ({ ...d, open: false }));
      if (resolverRef.current) {
          resolverRef.current(result);
          resolverRef.current = null;
      }
  }, []);

  const alert = useCallback(
      (opts) =>
          new Promise((resolve) => {
              resolverRef.current = resolve;

              setDialog({
                  open: true,
                  type: opts?.type || "alert",
                  variant: opts?.variant || "info",
                  icon: opts?.icon || "alert",
                  title: opts?.title || "",
                  message: opts?.message || "",
                  confirmText: opts?.confirmText || "Ok",
                  cancelText: opts?.cancelText || "Cancel",
                  showCancel: Boolean(opts?.showCancel),
              });
          }),
      []
  );


  useEffect(() => {
      const onDocMouseDown = (e) => {
          if (moreMenuRef.current && !moreMenuRef.current.contains(e.target)) {
              setMoreMenuOpen(false);
          }

          const target = e?.target;
          const isInMuiPicker =
              target &&
              typeof target.closest === "function" &&
              (target.closest(".MuiPickersPopper-root") ||
                  target.closest(".MuiDialog-root") ||
                  target.closest(".MuiModal-root"));

          if (!isInMuiPicker && customPopoverRef.current && !customPopoverRef.current.contains(target)) {
              setCustomPopoverOpen(false);
          }
      };

      document.addEventListener('mousedown', onDocMouseDown);
      return () => document.removeEventListener('mousedown', onDocMouseDown);
  }, []);

      const open = useContext(CollapseContext);
      const setSidenavOpen = useCallback((nextOpen) => {
          window.dispatchEvent(
              new CustomEvent('sama:sidenav:set-open', {
                  detail: { open: Boolean(nextOpen) },
              }),
          );
      }, []);

      useEffect(() => {
          if (isDashboardExpanded) {
              const sidenavElement = document.querySelector('[data-sidenav-open]');
              const attrValue = sidenavElement?.getAttribute('data-sidenav-open');
              previousSidenavOpenRef.current = attrValue ? attrValue === 'true' : Boolean(open);

              setSidenavOpen(false);
              setMoreMenuOpen(false);
              setCustomPopoverOpen(false);
          } else if (wasDashboardExpandedRef.current) {
              setSidenavOpen(previousSidenavOpenRef.current);
          }

          wasDashboardExpandedRef.current = isDashboardExpanded;
      }, [isDashboardExpanded, open, setSidenavOpen]);

      useEffect(() => {
          if (typeof document === 'undefined') return undefined;

          document.body.classList.toggle('dashboard-view-fullscreen', isDashboardExpanded);
          window.requestAnimationFrame?.(() => window.dispatchEvent(new Event('resize')));

          return () => {
              document.body.classList.remove('dashboard-view-fullscreen');
          };
      }, [isDashboardExpanded]);

      useEffect(() => {
          if (!isDashboardExpanded) return;

          const onKeyDown = (event) => {
              if (event.key === 'Escape') {
                  setIsDashboardExpanded(false);
              }
          };

          document.addEventListener('keydown', onKeyDown);
          return () => document.removeEventListener('keydown', onKeyDown);
      }, [isDashboardExpanded]);

      useEffect(() => {
          return () => {
              if (wasDashboardExpandedRef.current) {
                  setSidenavOpen(previousSidenavOpenRef.current);
              }
          };
      }, [setSidenavOpen]);

      const hasDashboardTabs = Boolean(template?.webdashboard?.length);
      const fallbackDashboardHeight = isDashboardExpanded
          ? Math.max(320, dims.height - 180)
          : Math.max(280, dims.height - 300);
      const maxHeight = `${dashboardViewportHeight || fallbackDashboardHeight}px`;

      const updateDashboardViewportHeight = useCallback(() => {
          if (typeof window === 'undefined') {
              return;
          }

          const bodyElement = dashboardBodyRef.current;
          const viewportElement = dashboardViewportRef.current;

          if (!bodyElement || !viewportElement) {
              setDashboardViewportHeight(null);
              return;
          }

          const bodyRect = bodyElement.getBoundingClientRect();
          const viewportRect = viewportElement.getBoundingClientRect();
          const dashboardTopSpacing = 8;
          const nextHeight = Math.floor(bodyRect.bottom - viewportRect.top - dashboardTopSpacing);

          if (!Number.isFinite(nextHeight) || nextHeight <= 0) {
              setDashboardViewportHeight(null);
              return;
          }

          setDashboardViewportHeight((prev) => (prev === nextHeight ? prev : nextHeight));
      }, []);

      useEffect(() => {
          if (!hasDashboardTabs) {
              setDashboardViewportHeight(null);
              return undefined;
          }

          if (typeof window === 'undefined') {
              return undefined;
          }

          let rafId = 0;
          const scheduleViewportMeasure = () => {
              if (rafId) {
                  window.cancelAnimationFrame(rafId);
              }

              rafId = window.requestAnimationFrame(() => {
                  updateDashboardViewportHeight();
              });
          };

          scheduleViewportMeasure();

          if (typeof ResizeObserver === 'undefined') {
              window.addEventListener('resize', scheduleViewportMeasure);

              return () => {
                  if (rafId) {
                      window.cancelAnimationFrame(rafId);
                  }
                  window.removeEventListener('resize', scheduleViewportMeasure);
              };
          }

          const resizeObserver = new ResizeObserver(() => {
              scheduleViewportMeasure();
          });

          [dashboardBodyRef.current, dashboardViewportRef.current]
              .filter(Boolean)
              .forEach((element) => resizeObserver.observe(element));

          window.addEventListener('resize', scheduleViewportMeasure);

          return () => {
              if (rafId) {
                  window.cancelAnimationFrame(rafId);
              }
              resizeObserver.disconnect();
              window.removeEventListener('resize', scheduleViewportMeasure);
          };
      }, [
          currentDashboard,
          hasDashboardTabs,
          isDashboardExpanded,
          updateDashboardViewportHeight,
      ]);

      const rangesAll = useMemo(() => devTranslations[lang].ranges || [], [lang]);
      const rangesPreset = useMemo(
          () => (
              Array.isArray(rangesAll)
                  ? rangesAll.filter((r) => String(r?.key || '').toLowerCase() !== 'custom')
                  : []
          ),
          [rangesAll]
      );

      const ranges_sec = [600, 3600, 21600, 86400, 604800, 2592000, 7776000, 15552000, 31104000];

      const customDatePickerSlotProps = {
          ...(textFieldSlotProps || {}),
          textField: {
              ...((textFieldSlotProps && textFieldSlotProps.textField) ? textFieldSlotProps.textField : {}),
              className: 'dd-custom-date-field',
              fullWidth: true,
              placeholder: 'DD/MM/YYYY',
          },
          popper: {
              ...((textFieldSlotProps && textFieldSlotProps.popper) ? textFieldSlotProps.popper : {}),
              disablePortal: true,
              placement: isRtl ? 'bottom-start' : 'bottom-end',
          },
          desktopPaper: {
              className: 'dd-date-picker-paper',
          },
          dialog: {
              className: 'dd-date-picker-dialog',
          },
      };

      const actions = [
              permissions['rename_devices'] ?
                  {
                      title: devTranslations[lang].tooltipRename,
                      icon: <RenameIcon />,
                      action: (id) => details.data && setRename({ open: true, id: id })
                  } : null,
              permissions['transfer_devices'] ? {
                  title: devTranslations[lang].tooltipTransfer,
                  icon: <TranferIcon />,
                  action: (id) => details.data && setTransfer({ open: true, id: id })
              } : null,

              permissions['reboot_devices'] ? {
                  title: devTranslations[lang].tooltipReboot,
                  icon: <RebootIcon />,
                  action: (device_id) => details.data && deviceAction(device_id, 'reboot', null, alert)
              } : null,
              permissions['view_user_actions_log'] ? {
                  title: devTranslations[lang].tooltipPing,
                  icon: <PingIcon />,
                  action: (device_id) => details.data && deviceAction(device_id, 'ping', null, alert)
              } : null,
              permissions['force_logout'] ? {
                  title: devTranslations[lang].tooltipDeleteData,
                  icon: <DeleteDataIcon />,
                  action: (did) => details.data && deleteDeviceData(did, alert)
              } : null,
              permissions['delete_devices'] ? {
                  title: devTranslations[lang].tooltipDelete,
                  icon: <DeleteIcon color={'rgb(236, 69, 78)'} />,
                  action: (id) => details.data && deleteDevice(id, () => navigate('/devices'), alert)
              } : null
          ].filter(Boolean);

      const currentDashboardRef = useRef(currentDashboard);
      const currentRangeRef = useRef(currentRange);
      const isCustomActiveRef = useRef(isCustomActive);
      const customFromRef = useRef(customFrom);
      const customToRef = useRef(customTo);
      const latestTemplateRef = useRef(template);
      const latestStreamDataRef = useRef(null);
      const latestEvaluateValueRef = useRef(null);
      const detailsDidRef = useRef(details.data?.did || '');
      const detailsStatusRef = useRef(details.data?.status || '');
      const periodColumnRefreshTimeoutRef = useRef(null);
      const periodColumnLastRefreshAtRef = useRef(Date.now());
      const chartHistoryRequestVersionRef = useRef(0);
      const periodColumnRequestVersionRef = useRef(0);


      useEffect(() => {
          currentDashboardRef.current = currentDashboard;
      }, [currentDashboard]);

      useEffect(() => {
          currentRangeRef.current = currentRange;
      }, [currentRange]);

      useEffect(() => {
          isCustomActiveRef.current = isCustomActive;
      }, [isCustomActive]);

      useEffect(() => {
          customFromRef.current = customFrom;
      }, [customFrom]);

      useEffect(() => {
          customToRef.current = customTo;
      }, [customTo]);
      
      useEffect(() => {
          latestTemplateRef.current = template;
      }, [template]);

      useEffect(() => {
          latestStreamDataRef.current = latestStreamData;
      }, [latestStreamData]);

      useEffect(() => {
          detailsDidRef.current = details.data?.did || '';
      }, [details.data?.did]);

      useEffect(() => {
          detailsStatusRef.current = details.data?.status || '';
      }, [details.data?.status]);

      useEffect(() => () => {
          if (periodColumnRefreshTimeoutRef.current) {
              clearTimeout(periodColumnRefreshTimeoutRef.current);
              periodColumnRefreshTimeoutRef.current = null;
          }
      }, []);


      const compareLevels = (a, b) => {
          const levels = ['bad', 'acceptable', 'good', 'perfect'];
          return levels.indexOf(a) - levels.indexOf(b);
      };

      const findDatastreamById = useCallback((datastreamList, rawId) => {
          const list = Array.isArray(datastreamList) ? datastreamList : [];
          if (rawId === null || rawId === undefined || rawId === '') {
              return null;
          }

          const numericId = Number(rawId);
          if (Number.isFinite(numericId)) {
              const byNumericId = list.find((ds) => Number(ds?.id) === numericId);
              if (byNumericId) return byNumericId;
          }

          return list.find((ds) => String(ds?.id) === String(rawId)) || null;
      }, []);


  const evaluateValue = useCallback((value, stream, templateEvaluationData) => {
    const val = parseFloat(value);
    if (!stream?.id || isNaN(val)) return null;

    const globalEvals = Array.isArray(templateEvaluationData?.evaluation_names)
      ? templateEvaluationData.evaluation_names
      : [];

    const allRanges = Array.isArray(templateEvaluationData?.datastream_ranges)
      ? templateEvaluationData.datastream_ranges
      : [];

    const dsRanges = allRanges.filter(r => String(r?.datastream_id) === String(stream.id));

    if (dsRanges.length === 0) return null;

    const combinedRanges = dsRanges
      .map(localRange => {
        const globalEval = globalEvals.find(
          e => String(e?.template_datastream_evaluation_id) === String(localRange?.template_datastream_evaluation_id)
        );

        const evalMeta = globalEval
          ? { ...globalEval, colorLight: globalEval?.colorLight ?? globalEval?.color_light }
          : {};

        const resolvedColor = getThemeColorValue(evalMeta, 'color', themeMode, null);

        return {
          name: globalEval?.name || 'Unknown',
          priority: globalEval?.priority != null ? Number(globalEval.priority) : 999,
          color: resolvedColor,
          from: localRange?.from_value != null ? parseFloat(localRange.from_value) : null,
          to: localRange?.to_value != null ? parseFloat(localRange.to_value) : null,
        };
      })
      .filter(r => r.from != null || r.to != null);

    if (combinedRanges.length === 0) return null;

    combinedRanges.sort((a, b) => a.priority - b.priority);

    for (const range of combinedRanges) {
      const withinFrom = range.from == null || val >= range.from;
      const withinTo = range.to == null || val <= range.to;

      if (withinFrom && withinTo) {
        return {
          name: range.name,
          key: String(range.name).toLowerCase(),
          priority: range.priority,
          color: range.color ?? null,
        };
      }
    }

    return {
      name: 'Bad',
      key: 'bad',
      priority: 999,
    };
  }, [themeMode]);

      useEffect(() => {
          latestEvaluateValueRef.current = evaluateValue;
      }, [evaluateValue]);

      useEffect(() => {
          const streamData = latestStreamDataRef.current;
          const currentTemplate = latestTemplateRef.current;
          const evaluate = latestEvaluateValueRef.current;

          if (!streamData || !currentTemplate?.datastreams || !evaluate) {
              return;
          }

          const templateEvalsData =
              currentTemplate.templateEvaluationData || { evaluation_names: [], datastream_ranges: [] };

          let worst = null;

          Object.keys(streamData).forEach((pin) => {
              const stream = currentTemplate.datastreams?.find((ds) => ds.pin === pin);
              const val = parseFloat(streamData[pin]);

              if (stream  && stream.id != null && !isNaN(val)) {
                  const ev = evaluate(val, stream, templateEvalsData);
                  if (!ev) return;

                  if (!worst || ev.priority > worst.priority) {
                      worst = ev;
                  }
              }
          });
          if (worst) {
              setWorstStatus((prev) => {
                  if (
                      (prev?.key || '') !== (worst?.key || '') ||
                      (prev?.priority ?? -1) !== (worst?.priority ?? -1) ||
                      (prev?.color || '') !== (worst?.color || '')
                  ) {
                      return worst;
                  }
                  return prev;
              });
          }
      }, [themeMode,latestStreamData]);

      const clearLiveChartSeries = useCallback((dashboardIndex = currentDashboardRef.current) => {
          setTemplate(prev => {
              if (!prev?.webdashboard?.[dashboardIndex]) return prev;

              let changed = false;
              const nextDashboards = prev.webdashboard.map((dashboard, idx) => {
                  if (idx !== dashboardIndex) return dashboard;

                  const nextWidgets = (dashboard.widgets || []).map((widget) => {
                      if (widget.type !== 'chart' && widget.type !== 'table') return widget;
                      if (!widget.extra_props?.isLiveRange) return widget;

                      const currentX = Array.isArray(widget.extra_props?.xData)
                          ? widget.extra_props.xData
                          : [];
                      const nextCurves = (widget.extra_props?.curves || []).map((curve) => {
                          if (!Array.isArray(curve?.yData) || curve.yData.length === 0) return curve;
                          changed = true;
                          return { ...curve, yData: [] };
                      });

                      if (currentX.length > 0) changed = true;

                      return {
                          ...widget,
                          extra_props: {
                              ...widget.extra_props,
                              xData: [],
                              curves: nextCurves,
                          },
                      };
                  });

                  return changed ? { ...dashboard, widgets: nextWidgets } : dashboard;
              });

              return changed ? { ...prev, webdashboard: nextDashboards } : prev;
          });
      }, []);

      const carryForwardSeries = useCallback((values = []) => {
          let lastValue = null;
          return values.map((value) => {
              if (value === undefined || value === null || value === '') {
                  return lastValue;
              }

              const numeric = Number(value);
              if (Number.isFinite(numeric)) {
                  lastValue = numeric;
                  return numeric;
              }

              lastValue = value;
              return value;
          });
      }, []);

      const StatusIndicator = ({ statusKey, displayName, t, color: colorOverride }) => {
    const key = String(statusKey ?? '').toLowerCase();

    const safeOverride =
    typeof colorOverride === 'string' && colorOverride.trim()
      ? colorOverride.trim()
      : null;
      
    // const statusClassFromKey = (() => {
    //   const k = String(key);
    //   if (k.includes('perfect') || k.includes('excellent') || k.includes('perfecto') || k.includes('ممتاز')) return 'dd-status-perfect';
    //   if (k.includes('very good') || (k.includes('good') && !k.includes('very')) || k.includes('جيد')) return 'dd-status-good';
    //   if (k.includes('acceptable') || k.includes('ok') || k.includes('مقبول')) return 'dd-status-acceptable';
    //   if (k.includes('bad') || k.includes('poor') || k.includes('سيء') || k.includes('mal')) return 'dd-status-bad';
    //   return 'dd-status-default';
    // })();

    const textStyle = safeOverride ? { color: safeOverride } : undefined;

    return (
      <div className={`dd-status-indicator`}>
        <span className="dd-status-text" style={textStyle}>
          {t?.[key] || displayName || capitalize(key)}
        </span>
      </div>
    );
  };




      async function fieldQuery(widget, requestVersion) {
          const selectedTemplate = latestTemplateRef.current;
          const selectedDashboardIndex = currentDashboardRef.current;
          const selectedRangeIndex = currentRangeRef.current;
          const selectedIsCustomActive = isCustomActiveRef.current;
          const selectedCustomFrom = customFromRef.current;
          const selectedCustomTo = customToRef.current;
          const selectedDid = detailsDidRef.current;

          const fields = (widget.extra_props?.curves || [])
              .map((curve) => ({
                  field: String(curve?.pin || '').trim(),
                  fn: normalizeWidgetAggregation(curve?.aggregation, widget?.type),
              }))
              .filter(({ field }) => field && field.toLowerCase() !== 'pin');
          const now = new Date();
          let tstart, tstop, rangeSeconds;

          if (selectedIsCustomActive && selectedCustomFrom && selectedCustomTo) {
              const fromEpoch = dayjs(selectedCustomFrom).unix();
              const toEpoch = dayjs(selectedCustomTo).unix();
              if (fromEpoch >= toEpoch) {
                  console.log("Invalid custom range: From should be before To");
                  showAlert(
                      'warning',
                      L.customInvalidRangeError || 'Invalid custom time range: "From" date must be before "To" date.'
                  );
                  return;
              }
              tstart = fromEpoch;
              tstop = toEpoch;
              rangeSeconds = tstop - tstart;
          } else {
              const epoch = Math.floor(now.getTime() / 1000);
              tstart = epoch - ranges_sec[selectedRangeIndex];
              tstop = epoch;
              rangeSeconds = ranges_sec[selectedRangeIndex];
          }
          if (!tstart || !tstop) {
              return;
          }

          if (!selectedTemplate?.tid || !selectedDid || !fields || fields.length === 0) {
              console.warn("fieldQuery: Missing required data (template.tid, device.did, or fields) to make a request.");
              return;
          }

          const sampling = buildChartSamplingPayload({
              props: widget?.extra_props || {},
              legacyMode: 'device',
          });

          const body = {
              bucket: BUCKET_DEVICES,
              measurement: selectedTemplate.tid,
              device: selectedDid,
              fields: fields,
              tstart: tstart,
              tstop: tstop,
              sampling,
          };

          const isLive = !selectedIsCustomActive && (String(rangesPreset?.[selectedRangeIndex]?.key || '').toLowerCase() === 'live');
          const rangeWindowSec = selectedIsCustomActive && selectedCustomFrom && selectedCustomTo
              ? Math.max(0, tstop - tstart)
              : (ranges_sec?.[selectedRangeIndex] || 0);

          if (isLive && !isDeviceOnlineStatus(detailsStatusRef.current)) {
              setTemplate(prev => {
                  if (!prev) return null;

                  return {
                      ...prev,
                      webdashboard: prev.webdashboard?.map(
                          (dashboard, idx) => idx === selectedDashboardIndex ? {
                              ...dashboard,
                              widgets: dashboard.widgets.map(w => w.id === widget.id ? {
                                  ...w,
                                  extra_props: {
                                      ...w.extra_props,
                                      xData: [],
                                      min: new Date(tstart * 1000).toISOString(),
                                      max: new Date(tstop * 1000).toISOString(),
                                      isLiveRange: true,
                                      rangeWindowSec: rangeWindowSec,
                                      curves: w.extra_props.curves.map(c => ({
                                          ...c,
                                          yData: []
                                      }))
                                  }
                              } : w)
                          } : dashboard)
                  };
              });
              return;
          }

          try {
              const res = await axios.post(
                  apiUrl(`data/fquery`),
                  body,
                  { headers: { "Content-Type": "application/json" } }
              );

              if (requestVersion !== chartHistoryRequestVersionRef.current) {
                  return;
              }

              const { xData: baseX, seriesByPin: normalizedRawY } = normalizeDeviceChartResponse(
                  res,
                  widget?.extra_props?.curves || [],
                  selectedDid
              );

              let xData = baseX;
              let yAxis = normalizedRawY;

              const indexed = baseX.map((t, i) => ({ i, ms: Date.parse(t) }));
              const canSort =
                  indexed.length > 1 &&
                  indexed.every((v) => Number.isFinite(v.ms));

              if (canSort) {
                  indexed.sort((a, b) => a.ms - b.ms);
                  xData = indexed.map((v) => baseX[v.i]);
                  yAxis = {};

                  Object.keys(normalizedRawY || {}).forEach((pin) => {
                      const arr = Array.isArray(normalizedRawY[pin]) ? normalizedRawY[pin] : [];
                      yAxis[pin] = carryForwardSeries(indexed.map((v) => arr[v.i]));
                  });
              } else {
                  yAxis = Object.keys(normalizedRawY || {}).reduce((acc, pin) => {
                      acc[pin] = carryForwardSeries(Array.isArray(normalizedRawY[pin]) ? normalizedRawY[pin] : []);
                      return acc;
                  }, {});
              }

              setTemplate(prev => {
                  if (!prev) return null;

                  return {
                      ...prev,
                      webdashboard: prev.webdashboard?.map(
                          (dashboard, idx) => idx === selectedDashboardIndex ? {
                              ...dashboard,
                              widgets: dashboard.widgets.map(w => w.id === widget.id ? {
                                  ...w,
                                  extra_props: {
                                      ...w.extra_props,
                                      xData: xData,
                                      min: new Date(tstart * 1000).toISOString(),
                                      max: new Date(tstop * 1000).toISOString(),
                                      isLiveRange: isLive,
                                      rangeWindowSec: rangeWindowSec,
                                      curves: (w.extra_props?.curves || []).map((c) => {
                                          const normalizedPin = String(c?.pin || '').trim();
                                          return {
                                              ...c,
                                              yData: Array.isArray(yAxis[normalizedPin]) ? yAxis[normalizedPin] : [],
                                          };
                                      })
                                  }
                              } : w)
                          } : dashboard)
                  };
              });

          } catch (err) {
              if (requestVersion !== chartHistoryRequestVersionRef.current) {
                  return;
              }
              console.error("Error fetching widget data:", err);
              const errorMessage = getErrorMessage(err);
              showAlert('error', `Could not load chart data: ${errorMessage}`);
          }
      }

      async function periodColumnQuery(widget, requestVersion) {
          const selectedTemplate = latestTemplateRef.current;
          const selectedDashboardIndex = currentDashboardRef.current;
          const selectedDid = detailsDidRef.current;
          if (!selectedTemplate?.tid || !selectedDid) {
              return;
          }

          const { pin } = resolvePeriodColumnWidgetBinding({
              widget,
              datastreams: selectedTemplate?.datastreams || [],
          });

          if (!pin) {
              return;
          }

          const normalizedPeriod = normalizePeriodColumnPeriod(widget?.extra_props?.period);
          const normalizedStat = normalizePeriodColumnStat(widget?.extra_props?.stat);
          const {
              tstart,
              tstop,
              rangeWindowSec,
          } = getPeriodColumnQueryRange(normalizedPeriod);
          const queryPeriod = normalizedPeriod === 'week' ? 'day' : normalizedPeriod;

          const applyWidgetSeries = (xData, yData) => {
              if (requestVersion !== periodColumnRequestVersionRef.current) {
                  return;
              }
              setTemplate(prev => {
                  if (!prev) return null;

                  return {
                      ...prev,
                      webdashboard: prev.webdashboard?.map((dashboard, idx) => idx === selectedDashboardIndex ? {
                          ...dashboard,
                          widgets: dashboard.widgets.map(w => w.id === widget.id ? {
                              ...w,
                              extra_props: {
                                  ...w.extra_props,
                                  xData,
                                  yData,
                                  period: normalizedPeriod,
                                  stat: normalizedStat,
                                  min: new Date(tstart * 1000).toISOString(),
                                  max: new Date(tstop * 1000).toISOString(),
                                  isLiveRange: true,
                                  rangeWindowSec,
                              }
                          } : w)
                      } : dashboard)
                  };
              });
          };

          const fetchRawAggregatedSeries = async () => {
              const rawRes = await axios.post(
                  apiUrl(`data/fquery`),
                  {
                      bucket: BUCKET_DEVICES,
                      measurement: selectedTemplate.tid,
                      device: selectedDid,
                      fields: [{ field: pin, fn: 'raw' }],
                      tstart,
                      tstop,
                      twin: '1',
                  },
                  { headers: { "Content-Type": "application/json" } }
              );

              if (requestVersion !== periodColumnRequestVersionRef.current) {
                  return null;
              }

              const rawTimes = Array.isArray(rawRes?.data?.data?.t) ? rawRes.data.data.t : [];
              const rawValues = Array.isArray(rawRes?.data?.data?.[pin]) ? rawRes.data.data[pin] : [];

              return aggregatePeriodColumnSeries({
                  timestamps: rawTimes,
                  values: rawValues,
                  period: normalizedPeriod,
                  stat: normalizedStat,
                  nowInput: new Date(tstop * 1000),
              });
          };

          try {
              const res = await axios.post(
                  apiUrl(`data/pquery`),
                  {
                      bucket: BUCKET_DEVICES,
                      measurement: selectedTemplate.tid,
                      device: selectedDid,
                      field: pin,
                      period: queryPeriod,
                      stat: normalizedStat,
                      tstart,
                      tstop,
                  },
                  { headers: { "Content-Type": "application/json" } }
              );

              if (requestVersion !== periodColumnRequestVersionRef.current) {
                  return;
              }

              const responseTimes = Array.isArray(res?.data?.data?.t) ? res.data.data.t : [];
              const responseValues = Array.isArray(res?.data?.data?.values) ? res.data.data.values : [];
              const aggregated = aggregatePeriodColumnSeries({
                  timestamps: responseTimes,
                  values: responseValues,
                  period: normalizedPeriod,
                  stat: normalizedStat,
                  nowInput: new Date(tstop * 1000),
              });

              applyWidgetSeries(aggregated.xData, aggregated.yData);
          } catch (err) {
              if (requestVersion !== periodColumnRequestVersionRef.current) {
                  return;
              }
              if (isNotFoundApiError(err)) {
                  try {
                      const aggregated = await fetchRawAggregatedSeries();
                      if (aggregated) {
                          applyWidgetSeries(aggregated.xData, aggregated.yData);
                      }
                      return;
                  } catch (fallbackErr) {
                      if (requestVersion !== periodColumnRequestVersionRef.current) {
                          return;
                      }
                      console.error("Error fetching period column fallback data:", fallbackErr);
                      showAlert('error', `Could not load period column data: ${getErrorMessage(fallbackErr)}`);
                      return;
                  }
              }

              console.error("Error fetching period column widget data:", err);
              showAlert('error', `Could not load period column data: ${getErrorMessage(err)}`);
          }
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
      useEffect(() => {
          if (template.tid && details.data?.did) {
              const chartRequestVersion = chartHistoryRequestVersionRef.current + 1;
              const periodRequestVersion = periodColumnRequestVersionRef.current + 1;
              chartHistoryRequestVersionRef.current = chartRequestVersion;
              periodColumnRequestVersionRef.current = periodRequestVersion;

              if (template.webdashboard && template.webdashboard.length > currentDashboard) {
                  template.webdashboard[
                      currentDashboard].widgets.forEach(widget => {
                          if (widget.type === 'chart' || widget.type === 'table') {
                              fieldQuery(widget, chartRequestVersion);
                          } else if (widget.type === PERIOD_COLUMN_WIDGET_TYPE) {
                              periodColumnQuery(widget, periodRequestVersion);
                          }
                      });
              }
          }
      }, [template.tid, details.data?.did, details.data?.status, currentDashboard, currentRange, isCustomActive, customFrom, customTo]);

      // eslint-disable-next-line react-hooks/exhaustive-deps
      useEffect(() => {
          if (!latestStreamData) return;
          const currentTemplate = latestTemplateRef.current;
          const currentTab = currentTemplate?.webdashboard?.[currentDashboard];
          if (!currentTab?.widgets?.length) return;

          const widgetsToRefresh = currentTab.widgets.filter((widget) => {
              if (widget?.type !== PERIOD_COLUMN_WIDGET_TYPE) {
                  return false;
              }

              const { pin } = resolvePeriodColumnWidgetBinding({
                  widget,
                  datastreams: currentTemplate?.datastreams || [],
              });

              return Boolean(pin && Object.prototype.hasOwnProperty.call(latestStreamData, pin));
          });

          if (widgetsToRefresh.length === 0) return;

          // Keep one trailing refresh and cap historical Influx queries instead of
          // querying once for every incoming telemetry message.
          if (periodColumnRefreshTimeoutRef.current) {
              return;
          }

          const scheduledDashboardIndex = currentDashboardRef.current;
          const elapsedMs = Date.now() - periodColumnLastRefreshAtRef.current;
          const refreshDelayMs = Math.max(750, PERIOD_COLUMN_INFLUX_REFRESH_MS - elapsedMs);

          periodColumnRefreshTimeoutRef.current = setTimeout(() => {
              periodColumnRefreshTimeoutRef.current = null;
              if (currentDashboardRef.current !== scheduledDashboardIndex) {
                  return;
              }
              periodColumnLastRefreshAtRef.current = Date.now();
              const requestVersion = periodColumnRequestVersionRef.current + 1;
              periodColumnRequestVersionRef.current = requestVersion;
              widgetsToRefresh.forEach((widget) => {
                  periodColumnQuery(widget, requestVersion);
              });
          }, refreshDelayMs);
      }, [latestStreamData, currentDashboard, details.data?.did]);

      useEffect(() => {
          const deviceId = parseInt(id);
          if (isNaN(deviceId) || deviceId < 1) {
              showAlert('error', L.invalidDeviceId || 'Invalid Device ID provided.');
              clearDeviceViewState();
              setDetails({ data: null, loading: false });
              setTimeout(() => navigate('/devices'), 3000);
              return;
          }

          const fetchDeviceAndTemplate = async () => {
              setIsDisabledBlocked(false);
              clearDeviceViewState();
              setDetails({ data: null, loading: true });

              try {
                  const deviceRes = await axios.get(apiUrl(`device/get/${deviceId}`));

                  if (!deviceRes.data || deviceRes.data.status !== 'OK') {
                      throw new Error('Incomplete or invalid device data received from server.');
                  }

                  const deviceData = deviceRes.data.data;
                  const isDisabledForCurrentUser =
                      String(deviceData?.plan_status || '').toLowerCase() === 'disabled';

                  if (isDisabledForCurrentUser) {
                      blockDisabledDeviceAccess();
                      return;
                  }

                  setDetails({ data: deviceData, loading: false });

                  if (deviceData.template_id) {
                      try {
                          const templateRes = await axios.get(apiUrl(`template/get/${deviceData.template_id}`));

                          if (templateRes.data && templateRes.data.status === 'OK') {
                              const templateData = templateRes.data.data;
                              
                              const combinedTemplateData = {
                                  ...templateData,
                                  templateEvaluationData: deviceData.templateEvaluationData 
                              };

                              if (combinedTemplateData.webdashboard && Array.isArray(combinedTemplateData.webdashboard)) {
                                  const filteredWebDashboards = combinedTemplateData.webdashboard.filter(wd =>
                                      checkTabPermission(userRole, wd.access_role || wd.access_roles)
                                  );
                                  combinedTemplateData.webdashboard = filteredWebDashboards;

                                  let newCurrentDashboard = parseInt(searchParams.get('tab')) || 0;

                                  if (newCurrentDashboard >= filteredWebDashboards.length && filteredWebDashboards.length > 0) {
                                      newCurrentDashboard = 0;
                                      setSearchParams({ tab: 0 }, { replace: true });
                                  } else if (filteredWebDashboards.length === 0 && newCurrentDashboard !== 0) {
                                      newCurrentDashboard = 0;
                                      setSearchParams({ tab: 0 }, { replace: true });
                                  } else if (newCurrentDashboard < 0) {
                                      newCurrentDashboard = 0;
                                      setSearchParams({ tab: 0 }, { replace: true });
                                  }
                                  
                                  setCurrentDashboard(newCurrentDashboard);

                              }

                              setTemplate(combinedTemplateData);
                          } else {
                              showAlert('warning', L.templateNotFound || 'Device template could not be loaded. Some features may be unavailable.');
                          }
                      } catch (templateError) {
                          console.error("Error fetching template:", templateError);
                          showAlert('warning', L.templateNotFound || `Could not load template: ${getErrorMessage(templateError)}`);
                      }
                  } else {
                      showAlert('info', 'This device is not associated with a template.');
                  }

              } catch (error) {
                  console.error("Error fetching device details:", error);
                  if (error?.response?.status === 403) {
                      blockDisabledDeviceAccess(error?.response?.data?.message || disabledAccessMessage);
                      return;
                  }

                  clearDeviceViewState();
                  setDetails({ data: null, loading: false });

                  showAlert('error', getErrorMessage(error, L));
                  setTimeout(() => navigate('/devices'), 3000);
              }
          };

          fetchDeviceAndTemplate();
      }, [blockDisabledDeviceAccess, clearDeviceViewState, disabledAccessMessage, id, navigate, lang, showAlert, userRole]);

      useEffect(() => {
          const deviceId = Number(details?.data?.id || id);
          const organizationId = Number(details?.data?.organization_id);

          if (!Number.isFinite(deviceId) || deviceId <= 0 || !Number.isFinite(organizationId) || organizationId <= 0) {
              setDeviceAssetCards([]);
              return;
          }

          let mounted = true;

          const fetchDeviceAssetCards = async () => {
              try {
                  const [configRes, assetsRes] = await Promise.all([
                      axios.get(apiUrl('configuration/public'), { params: { organization_id: organizationId } }),
                      permissions?.view_assets
                          ? axios.get(apiUrl('asset-card/by-organization'), { params: { organization_id: organizationId } })
                          : Promise.resolve({ data: { data: [] } }),
                  ]);

                  if (!mounted) return;

                  const normalizedConfig = normalizeAssetCardConfig(configRes.data?.data?.assetCard);
                  const maxItems = normalizedConfig.deviceDetailsMaxItems || DEFAULT_ASSET_CARD_CONFIG.deviceDetailsMaxItems;
                  const rows = Array.isArray(assetsRes.data?.data) ? assetsRes.data.data : [];
                  const relatedAssets = rows
                      .filter((asset) => Number(asset?._device_id ?? asset?.device_id ?? asset?.Device?._row_id ?? asset?.Device?.id) === deviceId)
                      .slice(0, maxItems);

                  const configuredFields = normalizeStringList(normalizedConfig.deviceDetailsFields).slice(0, maxItems);

                  setAssetCardSummaryLimit(maxItems);
                  setAssetCardSummaryFields(configuredFields);
                  setDeviceAssetCards(relatedAssets);
              } catch (error) {
                  console.warn('Failed to load device asset cards', error);
                  if (mounted) {
                      setDeviceAssetCards([]);
                  }
              }
          };

          fetchDeviceAssetCards();

          return () => {
              mounted = false;
          };
      }, [details?.data?.id, details?.data?.organization_id, id, permissions?.view_assets]);
  useEffect(() => {
    if (!isDisabledForCurrentUser || isDisabledBlocked) return;

    blockDisabledDeviceAccess();
  }, [blockDisabledDeviceAccess, isDisabledBlocked, isDisabledForCurrentUser]);
  useEffect(() => {
    if (!isDeviceAccessBlocked) return;

    const timeoutId = setTimeout(() => {
      navigate('/devices', { replace: true });
    }, 1500);

    return () => clearTimeout(timeoutId);
  }, [isDeviceAccessBlocked, navigate]);
  useEffect(() => {
    const deviceId = parseInt(id);
    if (isNaN(deviceId) || deviceId < 1) {
      showAlert('error', L.invalidDeviceId || 'Invalid Device ID provided.');
      return;
    }

    if (isDeviceAccessBlocked) return;
    if (!details?.data?.id || Number(details.data.id) !== deviceId) return;

    let es = null;
    allDataRef.current = {};

    const startDeviceSSE = () => {
      es = new EventSource(apiUrl(`device/get-sse/${deviceId}`), {
        withCredentials: true
      });

      es.onopen = () => console.log("[SSE] Device connected");

      es.onmessage = (event) => {
        try {
          const payload = JSON.parse(event.data);

          if (payload?.status === 'FORBIDDEN') {
            blockDisabledDeviceAccess(payload?.message || disabledAccessMessage);
            es?.close();
            return;
          }

          if (payload?.status === 'DELETED') {
            es?.close();
            clearDeviceViewState();
            setDetails({ data: null, loading: false });
            showAlert('error', payload?.message || L.deviceDeleted || 'This device is no longer available.');
            setTimeout(() => navigate('/devices', { replace: true }), 1500);
            return;
          }

          if (payload?.status === 'ERROR' || !payload?.data) {
            console.warn('[SSE] Ignoring non-OK device payload', payload);
            return;
          }

          setDetails({ data: payload.data, loading: false });

          if (!isDeviceOnlineStatus(payload.data?.status)) {
            allDataRef.current = {};
            latestStreamDataRef.current = null;
            setLatestStreamData(null);
            clearLiveChartSeries(currentDashboardRef.current);
          } else if (payload.latestStreamData && typeof payload.latestStreamData === 'object') {
            const mergedData = updateLatestStreamData(
              normalizeDeviceLivePayload(payload.latestStreamData, payload.data?.did || detailsDidRef.current)
            );
            setLatestStreamData(mergedData);
          }
          if (payload.worstStatus) setWorstStatus(payload.worstStatus);

        } catch (err) {
          console.error("[SSE] JSON decode error:", err);
        }
      };

      es.onerror = (err) => {
        if (isDeviceAccessBlocked) return;
        console.warn("[SSE] lost connection - retrying in 3s", err);
        es.close();
        setTimeout(startDeviceSSE, 3000); 
      };
    };

    startDeviceSSE();

    return () => {
      if (es) es.close();
    };
  }, [L, blockDisabledDeviceAccess, clearDeviceViewState, clearLiveChartSeries, details.data?.id, disabledAccessMessage, id, isDeviceAccessBlocked, navigate, showAlert]);

  const updateWidgetsWithStreamData = useCallback((streamData, tabIndex, currentTemplate) => {
    if (
      !streamData ||
      !currentTemplate
    ) {
      return currentTemplate;
    }

    const selectedRangeKey = String(rangesPreset?.[currentRangeRef.current]?.key || '').toLowerCase();
    const isSelectedLiveRange = !isCustomActiveRef.current && selectedRangeKey === 'live';
    const isDeviceOnline = isDeviceOnlineStatus(detailsStatusRef.current);

    const currentDatastreams = Array.isArray(currentTemplate.datastreams)
      ? currentTemplate.datastreams
      : [];
    let hasDatastreamChanged = false;
    const updatedDatastreams = currentDatastreams.map((datastream) => {
      if (!datastream?.pin) return datastream;
      if (!Object.prototype.hasOwnProperty.call(streamData, datastream.pin)) {
        return datastream;
      }

      const nextValue = streamData[datastream.pin];
      if (datastream.value === nextValue) {
        return datastream;
      }

      hasDatastreamChanged = true;
      return {
        ...datastream,
        value: nextValue,
      };
    });

    if (
      !currentTemplate.webdashboard ||
      currentTemplate.webdashboard.length === 0 ||
      !currentTemplate.webdashboard[tabIndex]
    ) {
      return hasDatastreamChanged
        ? { ...currentTemplate, datastreams: updatedDatastreams }
        : currentTemplate;
    }

    const datastreams = updatedDatastreams;
    const targetDashboard = currentTemplate.webdashboard[tabIndex];

    let hasWidgetChanged = false;

    const nowMs = Date.now();
    const streamKeys = Object.keys(streamData);
    const findStreamKey = (pin) => {
      const wantedPin = String(pin || '').trim().toLowerCase();
      if (!wantedPin) return null;
      return streamKeys.find((key) => String(key).trim().toLowerCase() === wantedPin) || null;
    };

    let updatedWidgets = (targetDashboard.widgets || []).map(widget => {
      if (widget.type === 'chart' || widget.type === 'table') {
        const curves = widget.extra_props?.curves || [];
        const isLiveRange = Boolean(widget.extra_props?.isLiveRange);

        if (isSelectedLiveRange && isLiveRange && !isDeviceOnline) {
          return widget;
        }

        if (!isSelectedLiveRange || !isLiveRange || curves.length === 0) {
          return widget;
        }

        const hasAnyPin = curves.some((c) => Boolean(findStreamKey(c?.pin)));
        if (!hasAnyPin) return widget;

        const rangeWindowSec = Number(widget.extra_props?.rangeWindowSec) || 0;
        const cutoffMs = rangeWindowSec ? nowMs - rangeWindowSec * 1000 : null;

        const currentX = Array.isArray(widget.extra_props?.xData)
          ? [...widget.extra_props.xData]
          : [];
        const lastMs = currentX.length
          ? Date.parse(currentX[currentX.length - 1])
          : null;
        const nextMs =
          Number.isFinite(lastMs) && nowMs <= lastMs ? lastMs + 1 : nowMs;
        const nextIso = new Date(nextMs).toISOString();
        currentX.push(nextIso);

        let trimmedCount = 0;
        if (cutoffMs) {
          while (currentX.length > 0) {
            const t = Date.parse(currentX[0]);
            if (Number.isFinite(t) && t < cutoffMs) {
              currentX.shift();
              trimmedCount += 1;
            } else {
              break;
            }
          }
        }

        const nextCurves = curves.map((c) => {
          const prevY = Array.isArray(c.yData) ? [...c.yData] : [];
          const streamKey = findStreamKey(c?.pin);
          const raw = streamKey
            ? streamData[streamKey]
            : (prevY.length ? prevY[prevY.length - 1] : null);
          const numeric = Number(raw);
          const nextVal = Number.isFinite(numeric) ? numeric : (raw ?? null);
          prevY.push(nextVal);
          if (trimmedCount > 0) {
            prevY.splice(0, trimmedCount);
          }
          return { ...c, yData: prevY };
        });

        hasWidgetChanged = true;

        return {
          ...widget,
          extra_props: {
            ...widget.extra_props,
            xData: currentX,
            curves: nextCurves,
            min: rangeWindowSec ? new Date(nowMs - rangeWindowSec * 1000).toISOString() : widget.extra_props?.min,
            max: new Date(nowMs).toISOString(),
          },
        };
      }

      if (widget.type === 'terminal') {
        if (widget.data_id === null || widget.data_id === undefined || widget.data_id === '') return widget;
        const ds = findDatastreamById(datastreams, widget.data_id);
        if (!ds || !ds.pin) return widget;
        if (!Object.prototype.hasOwnProperty.call(streamData, ds.pin)) {
          return widget;
        }
        const rawIncomingValue = streamData[ds.pin];
        if (rawIncomingValue === undefined || rawIncomingValue === null) return widget;

        const incomingText = String(rawIncomingValue);
        if (incomingText.length === 0) return widget;

        const previousLiveValue = widget.extra_props?.__lastLiveValue == null
          ? null
          : String(widget.extra_props.__lastLiveValue);
        if (previousLiveValue === incomingText) return widget;

        const previousText = widget.extra_props?.value == null
          ? ''
          : String(widget.extra_props.value);
        const separator = widget.extra_props?.newLine ? '\r\n' : '';
        const nextText = previousText
          ? `${previousText}${separator}${incomingText}`
          : incomingText;

        hasWidgetChanged = true;
        return {
          ...widget,
          extra_props: {
            ...widget.extra_props,
            value: nextText,
            __lastLiveValue: incomingText
          }
        };
      }

      if (widget.type === 'time-range') {
        const currentStreams = widget.extra_props?.streams || {};
        const nextStreams = { ...currentStreams };
        let streamChanged = false;

        ['hours', 'minutes'].forEach((streamKey) => {
          const configuredStream = currentStreams?.[streamKey];
          if (!configuredStream?.dataId) return;

          const ds = findDatastreamById(datastreams, configuredStream.dataId);
          if (!ds?.pin) return;
          if (!Object.prototype.hasOwnProperty.call(streamData, ds.pin)) return;

          const nextValue = streamData[ds.pin];
          if (configuredStream.value === nextValue) return;

          streamChanged = true;
          nextStreams[streamKey] = {
            ...configuredStream,
            value: nextValue
          };
        });

        if (!streamChanged) {
          return widget;
        }

        hasWidgetChanged = true;

        return {
          ...widget,
          extra_props: {
            ...widget.extra_props,
            streams: nextStreams
          }
        };
      }

      if (widget.data_id === null || widget.data_id === undefined || widget.data_id === '') {
        return widget;
      }

      const ds = findDatastreamById(datastreams, widget.data_id);
      if (!ds || !ds.pin) return widget;

      if (!Object.prototype.hasOwnProperty.call(streamData, ds.pin)) {
        return widget;
      }

      const newValue = streamData[ds.pin];

      if (widget.extra_props?.value === newValue) {
        return widget;
      }

      hasWidgetChanged = true;

      return {
        ...widget,
        extra_props: {
          ...widget.extra_props,
          value: newValue
        }
      };
    });

    updatedWidgets = updatedWidgets.map(widget => {
      if (widget.type !== 'fan') return widget;

      const fanCfg = widget.extra_props?.datastreams || [];
      const active = fanCfg.find(x => x?.isActive);
      const activePin = active?.pin;

      if (!activePin) return widget; 

      if (!Object.prototype.hasOwnProperty.call(streamData, activePin)) {
        return widget;
      }

      const newValue = streamData[activePin];

      if (widget.extra_props?.value === newValue) {
        return widget;
      }

      hasWidgetChanged = true;

      return {
        ...widget,
        extra_props: {
          ...widget.extra_props,
          value: newValue
        }
      };
    });

    if (!hasWidgetChanged && !hasDatastreamChanged) {
      return currentTemplate;
    }

    const updatedWebDashboards = currentTemplate.webdashboard.map((dashboard, idx) => {
      if (idx === tabIndex) {
        return { ...dashboard, widgets: updatedWidgets };
      }
      return dashboard;
    });

    return {
      ...currentTemplate,
      datastreams: updatedDatastreams,
      webdashboard: updatedWebDashboards,
    };
  }, [findDatastreamById, rangesPreset]);

      
      useEffect(() => {
          if (!latestStreamData) return;

          setTemplate(prev => {
              const updatedTemplate = updateWidgetsWithStreamData(
                  latestStreamData,
                  currentDashboardRef.current, 
                  prev
              );
              return updatedTemplate;
          });
      }, [latestStreamData, updateWidgetsWithStreamData]);

      useEffect(() => {
          const streamData = latestStreamDataRef.current;
          if (!streamData) return;

          setTemplate((prev) => updateWidgetsWithStreamData(streamData, currentDashboard, prev));
      }, [currentDashboard, updateWidgetsWithStreamData]);
  function updateLatestStreamData(newData) {
    const currentData = (allDataRef.current && typeof allDataRef.current === 'object')
      ? allDataRef.current
      : {};
    const updatedData = { ...currentData };
    let hasChanges = false;

    for (const key in (newData || {})) {
      if (newData[key] !== undefined && newData[key] !== currentData[key]) {
        updatedData[key] = newData[key];
        hasChanges = true;
      }
    }

    if (!hasChanges) {
      return currentData;
    }

    allDataRef.current = updatedData;
    return updatedData;
  }

  useEffect(() => {
    if (!details?.data?.did || isDeviceAccessBlocked) {
      return undefined;
    }

    if (!isDeviceOnlineStatus(details.data?.status)) {
      return undefined;
    }

    let streamSource = null;
    let retryTimeout = null;
    let closed = false;

    const startSensorStream = () => {
      const did = encodeURIComponent(details.data.did);
      streamSource = new EventSource(sensorsUrl(`stream?device=${did}`));

      streamSource.onmessage = (event) => {
        try {
          const payload = JSON.parse(event.data);
          if (!payload || typeof payload !== 'object') {
            return;
          }

          const mergedData = updateLatestStreamData(
            normalizeDeviceLivePayload(payload, detailsDidRef.current)
          );
          if (mergedData !== latestStreamDataRef.current) {
            setLatestStreamData(mergedData);
          }
        } catch (error) {
          console.error('[Sensor SSE] JSON decode error:', error);
        }
      };

      streamSource.onerror = (error) => {
        if (closed || isDeviceAccessBlocked) {
          return;
        }

        console.warn('[Sensor SSE] lost connection - retrying in 3s', error);
        streamSource?.close();
        retryTimeout = setTimeout(() => {
          if (!closed) {
            startSensorStream();
          }
        }, 3000);
      };
    };

    startSensorStream();

    return () => {
      closed = true;
      if (retryTimeout) clearTimeout(retryTimeout);
      if (streamSource) streamSource.close();
    };
  }, [details.data?.did, details.data?.status, isDeviceAccessBlocked]);


      useEffect(() => {
          if (template && template.webdashboard && template.webdashboard.length > 0
              && template.datastreams && template.datastreams.length > 0) {
              const timeout = (template.webdashboard && template.webdashboard.length
                  && template.webdashboard.length > 0) ? 0 : 500;
              setTimeout(() => {
                  const border = document.querySelector('.dashboard-tab-border'),
                      t = document.querySelectorAll('.dashboard-tab')[currentDashboard],
                      dashboardWidth = t && document.defaultView.getComputedStyle(t).width;
                  if (border) {
                      border.style.width = dashboardWidth;
                      border.style.left = t.offsetLeft + 'px';
                      t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                  }
              }, timeout);
          }
      }, [currentDashboard, template]);

      useEffect(() => {
          const fetchTerminalDataForTemplate = async () => {
              const currentTab = template.webdashboard?.[currentDashboard];

              if (!template.tid || !details.data?.did || !currentTab) {
                  return;
              }

              const terminalPromises = [];
              const promiseMetadata = [];

              currentTab.widgets.forEach(widget => {
                  if (widget.type === 'terminal') {
                      const datastream = findDatastreamById(template.datastreams, widget.data_id);

                      if (datastream?.pin) {
                          const body = {
                              bucket: 'Sensors',
                              measurement: template.tid,
                              device: details.data.did,
                              field: datastream.pin
                          };

                          const promise = axios.post(
                              apiUrl(`data/tquery`),
                              body,
                              { headers: { "Content-Type": "application/json" } }
                          );

                          terminalPromises.push(promise);
                          promiseMetadata.push({ widgetId: widget.id });
                      }
                  }
              });

              if (terminalPromises.length === 0) {
                  return;
              }

              try {
                  const responses = await Promise.all(terminalPromises);

                  setTemplate(prev => {
                      if (!prev) return null;

                      const resultsMap = new Map();
                      responses.forEach((res, index) => {
                          const meta = promiseMetadata[index];
                          resultsMap.set(meta.widgetId, res.data.data);
                      });

                      return {
                          ...prev,
                          webdashboard: prev.webdashboard.map((dashboard, idx) =>
                              idx === currentDashboard
                                  ? {
                                      ...dashboard,
                                      widgets: dashboard.widgets.map(w => {
                                          const result = resultsMap.get(w.id);

                                          if (w.type === 'terminal' && result) {
                                              const textValues = Array.isArray(result?.text) ? result.text : [];
                                              const joinedText = w.extra_props?.newLine
                                                  ? textValues.join('\r\n')
                                                  : textValues.join('');
                                              const lastTerminalValue = textValues.length > 0
                                                  ? textValues[textValues.length - 1]
                                                  : null;
                                              return {
                                                  ...w,
                                                  extra_props: {
                                                      ...w.extra_props,
                                                      value: joinedText,
                                                      __lastLiveValue: lastTerminalValue != null ? String(lastTerminalValue) : null
                                                  }
                                              };
                                          }
                                          return w;
                                      })
                                  }
                                  : dashboard
                          )
                      };
                  });

              } catch (err) {
                  console.error("Error fetching terminal data for template:", err);
                  const errorMessage = getErrorMessage(err);
                  showAlert('error', `Could not load terminal data: ${errorMessage}`);
              }
          };

          fetchTerminalDataForTemplate();

      }, [template.tid, details.data?.did, currentDashboard]);


      const canShowActions = actions.length > 0;
      const canViewDeviceEvents = Boolean(permissions['view_device_events']);
      const canDownloadReports = Boolean(permissions['download_reports']);
      const canDownloadAiReports = Boolean(permissions['download_ai_reports']);
      const canOpenReportDialog = canDownloadReports || canDownloadAiReports;
      const downloadReportActionLabel = canDownloadReports
        ? (L.downloadReport || 'Download Report')
        : canDownloadAiReports
          ? (L.downloadAiReport || 'Download AI Report')
          : (L.downloadReport || 'Download Report');

      const canShowMoreMenuItems = canViewDeviceEvents || Boolean(permissions['view_devices']) || canOpenReportDialog || canShowActions;
      const canShowButtonGroup = canShowMoreMenuItems || Boolean(permissions['edit_devices']);
      const hasWebDashboard = hasDashboardTabs;

      const renderDeviceAssetCards = () => {
          if (!deviceAssetCards.length) return null;

          const selectedFields = getAssetCardDeviceDetailsFieldOptions(assetCardSummaryFields)
              .slice(0, assetCardSummaryLimit);
          const readAssetField = (asset, field) =>
              (field.path || []).reduce((value, key) => (value == null ? value : value[key]), asset);
          const formatAssetFieldValue = (value) => {
              if (value === null || value === undefined) return '';
              if (Array.isArray(value)) return value.length ? value.map((item) => (typeof item === 'object' ? JSON.stringify(item) : String(item))).join(', ') : '';
              if (typeof value === 'object') return Object.keys(value).length ? JSON.stringify(value) : '';
              return String(value).trim();
          };
          const formatAssetParts = (asset) => {
              const parts = selectedFields
                  .map((field) => {
                      const value = formatAssetFieldValue(readAssetField(asset, field));
                      if (!value) return null;
                      return {
                          label: field.label,
                          value,
                      };
                  })
                  .filter(Boolean);
              return parts.length
                  ? parts
                  : [{ label: 'Asset', value: asset.asset_name || asset.asset_code || asset.category_subcategory || 'Asset' }];
          };

          return (
              <div className="dd-device-asset-summary" aria-label={`Showing up to ${assetCardSummaryLimit} related asset cards`}>
                  {deviceAssetCards.map((asset) => {
                      const parts = formatAssetParts(asset);
                      const title = parts.map((part) => `${part.label}: ${part.value}`).join(' | ');
                      return (
                          <button
                              type="button"
                              key={asset._row_id || asset.id || asset.asset_code || asset.asset_name}
                              className="dd-device-asset-pill"
                              onClick={() => {
                                  const assetId = asset._row_id || asset.id;
                                  if (assetId) {
                                      navigate(`/asset-card/details/${assetId}`, {
                                          state: { returnTo: `${location.pathname}${location.search}${location.hash}` },
                                      });
                                  }
                              }}
                              title={title}
                          >
                              <AssetCardMainIcon />
                              <span className="dd-device-asset-fields">
                                  {parts.map((part) => (
                                      <span className="dd-device-asset-field" key={`${part.label}-${part.value}`}>
                                          <span className="dd-device-asset-label">{part.label}</span>
                                          <span className="dd-device-asset-value">{part.value}</span>
                                      </span>
                                  ))}
                              </span>
                          </button>
                      );
                  })}
              </div>
          );
      };

      const renderRangeControls = () => (
          <div className="dd-time-controls">
              <div className='details-time-range dd-time-range-pill'>
                  {rangesPreset.map(({ key, label }, idx) => {
                      const isActive = !isCustomActive && currentRange === idx;
                      return (
                          <button
                              key={idx}
                              type='button'
                              className={`details-control-btn dd-range-btn ${isActive ? 'active' : ''}`}
                              onClick={() => {
                                  setCurrentRange(idx);
                                  setIsCustomActive(false);
                              }}
                          >
                              {label}
                          </button>
                      );
                  })}
              </div>

              <div className="dd-custom-wrapper" ref={customPopoverRef}>
                  <button
                      type="button"
                      ref={customBtnRef}
                      className={`dd-custom-btn ${(customPopoverOpen || isCustomActive) ? 'active' : ''}`}
                      onClick={() => {
                          setCustomDraftFrom(customFrom);
                          setCustomDraftTo(customTo);
                          setCustomPopoverOpen((v) => !v);
                      }}
                  >
                      <CalendarMonthOutlinedIcon className="dd-custom-btn-icon" />
                      <span className="dd-custom-btn-label">
                          {isCustomActive && customFrom && customTo
                              ? `${dayjs(customFrom).format('DD/MM/YYYY')} - ${dayjs(customTo).format('DD/MM/YYYY')}`
                              : (rangesAll.find((r) => String(r?.key || '').toLowerCase() === 'custom')?.label || 'Custom')}
                      </span>
                  </button>

                  <div
                      className={`dd-custom-popover ${customPopoverOpen ? 'open' : ''} ${isRtl ? 'rtl' : ''}`}
                      style={{ top: customPopoverPos.top, left: customPopoverPos.left }}
                  >
                      <div className="dd-custom-popover-fields">
                          <div className="dd-custom-field">
                              <div className="dd-custom-field-label">{L.customFromLabel || 'From'}</div>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DatePicker
                                      value={customDraftFrom}
                                      onChange={(v) => {
                                          setCustomDraftFrom(v);
                                          if (customDraftTo && v && dayjs(customDraftTo).isBefore(v)) {
                                              setCustomDraftTo(v);
                                          }
                                      }}
                                      maxDate={customDraftTo || dayjs()}
                                      format="DD/MM/YYYY"
                                      slotProps={customDatePickerSlotProps}
                                  />
                              </LocalizationProvider>
                          </div>
                          <div className="dd-custom-field">
                              <div className="dd-custom-field-label">{L.customToLabel || 'To'}</div>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DatePicker
                                      value={customDraftTo}
                                      onChange={(v) => setCustomDraftTo(v)}
                                      minDate={customDraftFrom || undefined}
                                      maxDate={dayjs()}
                                      format="DD/MM/YYYY"
                                      slotProps={customDatePickerSlotProps}
                                  />
                              </LocalizationProvider>
                          </div>

                          <div className="dd-custom-popover-actions">
                              <button
                                  type="button"
                                  className="dd-custom-cancel"
                                  onClick={() => {
                                      setCustomPopoverOpen(false);
                                      setCustomDraftFrom(customFrom);
                                      setCustomDraftTo(customTo);
                                  }}
                              >
                                  {L.customCancel || 'Cancel'}
                              </button>

                              <button
                                  type="button"
                                  className="dd-custom-apply"
                                  onClick={() => {
                                      if (!customDraftFrom || !customDraftTo) {
                                          showAlert(
                                              'warning',
                                              L.customSelectDatesError || 'Please select both From and To dates.'
                                          );
                                          return;
                                      }

                                      const from = dayjs(customDraftFrom);
                                      const to = dayjs(customDraftTo);
                                      if (from.isAfter(to)) {
                                          showAlert(
                                              'warning',
                                              L.customInvalidRangeError || 'Invalid custom time range: "From" date must be before "To" date.'
                                          );
                                          return;
                                      }

                                      setCustomFrom(from);
                                      setCustomTo(to);
                                      setIsCustomActive(true);
                                      setCustomPopoverOpen(false);
                                  }}
                              >
                                  {L.customApply || 'Apply'}
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      );

      const renderExpandToggle = (extraClassName = '') => {
          if (!hasWebDashboard) return null;
          const className = `dd-expand-toggle${isDashboardExpanded ? ' active' : ''}${extraClassName ? ` ${extraClassName}` : ''}`;
          const expandLabel = isDashboardExpanded
              ? (L.collapseAction || 'Click to collapse')
              : (L.expandAction || 'Click to expand');
          return (
              <button
                  type="button"
                  className={className}
                  onClick={() => setIsDashboardExpanded((prev) => !prev)}
                  title={expandLabel}
                  aria-label={expandLabel}
              >
                  {isDashboardExpanded ? (
                      <CloseFullscreenIcon className="dd-expand-toggle-icon" />
                  ) : (
                      <OpenInFullIcon className="dd-expand-toggle-icon" />
                  )}
                  <span className="dd-expand-toggle-label">
                      {expandLabel}
                  </span>
              </button>
          );
      };

      return (details.loading ? <Spinner />
          : !permissions['view_devices'] ? <div>{L.noPermission}</div>
          : isDeviceAccessBlocked ? (
              <div
                  className='details-container dd-details-container'
                  dir={isRtl ? 'rtl' : 'ltr'}
              >
                  <Alert
                      open={alertState.open}
                      close={() => setAlertState((s) => ({ ...s, open: false }))}
                      message={alertState.message}
                      type={alertState.type}
                      position={alertState.position}
                  />
                  <div className="dd-no-data-center">
                      <div>{disabledAccessMessage}</div>
                      <button
                          type="button"
                          className="btn btn-cancel"
                          onClick={() => navigate('/devices', { replace: true })}
                      >
                          {L.backToDevices || 'Back to devices'}
                      </button>
                  </div>
              </div>
          )
          : details.data ?
                  <div
                      className='details-container dd-details-container'
                      dir={isRtl ? 'rtl' : 'ltr'}
                  >
                      <AppDialog
                          open={dialog.open}
                          type={dialog.type}
                          variant={dialog.variant}
                          icon={dialog.icon}
                          title={dialog.title}
                          message={dialog.message}
                          confirmText={dialog.confirmText}
                          cancelText={dialog.cancelText}
                          showCancel={dialog.showCancel}
                          onConfirm={() => closeDialog(true)}
                          onCancel={() => closeDialog(false)}
                          onClose={() => closeDialog(false)}
                      />
                      <Alert
                          open={alertState.open}
                          close={() => setAlertState((s) => ({ ...s, open: false }))}
                          message={alertState.message}
                          type={alertState.type}
                          position={alertState.position}
                      />
                      {report.open && (
                          <DownloadReport
                              template={template}
                              device={details}
                              state={report}
                              setState={setReport}
                              setLoadingReport={setLoadingReport}
                              onAlert={showAlert}
                              refresh={() => navigate('/report')}
                          />
                      )}
                      {loadingReport && (
                          <div className="dd-report-toast">
                              <div className="dd-report-toast-header">
                                  <span className="dd-report-toast-title">{L.generatingReport}</span>
                                  <span
                                      onClick={() => setLoadingReport(false)}
                                      className="dd-report-toast-close"
                                  >
                                      ✖
                                  </span>
                              </div>
                              <span className="dd-report-toast-sub">
                                  {L.reportReady}
                              </span>
                          </div>
                      )}
                      {showStatusModal.open && (
                          <DataEvaluationDetails
                              state={showStatusModal}
                              setState={setShowStatusModal}
                              template={template}
                              latestStreamData={latestStreamData}
                              allEvaluations={template.templateEvaluationData} 
                          />
                      )}
                      {rename.open ? <RenameDevice state={rename} setState={setRename} refresh={
                          () => navigate('/devices')} /> : null}
                      {editDid.open ? (
                          <EditDeviceId
                              state={editDid}
                              setState={setEditDid}
                              onUpdated={(updatedData) =>
                                  setDetails((prev) => ({
                                      ...prev,
                                      data: prev?.data ? { ...prev.data, ...updatedData } : prev?.data
                                  }))
                              }
                          />
                      ) : null}
                      {transfer.open ? <TransferDevice state={transfer} setState={setTransfer} refresh={
                          () => navigate('/devices')} /> : null}
                      {deviceEvents && canViewDeviceEvents && <DeviceEvents close={() => setDeviceEvents(false)}
                          templateId={template.tid} deviceId={details.data.did}
                          tstop={Math.floor(Date.now() / 1000)}
                          range={isCustomActive && customFrom && customTo
                              ? Math.max(0, Math.floor((dayjs(customTo).valueOf() - dayjs(customFrom).valueOf()) / 1000))
                              : ranges_sec[currentRange]}
                      />}

  <div className="details-control-panel">

      <div className="details-control-panel-inside" />

      <div className="details-control-panel-glow" />

      <div className="details-control-panel-content">

          <div className="details-control-btns details-control-btns-column">
              <button
                              type="button"
                              className="details-control-btn details-control-btn-ghost"
                              onClick={() => navigate('/devices')}
                          >
                              <MenuBackButtonIcon />
                          </button>
          </div>
          <div
                      className={
                          'details-control-divider details-control-divider-collapsed' 
                      }
                  >
                      <DividerMenuIcon/>
                  </div>

      </div>
  </div>

                      <div className={`details-content dd-details-content${isDashboardExpanded ? ' dd-content-expanded' : ''}`}>
  <div className={`details-head dd-details-head-modern${isDashboardExpanded ? ' dd-head-expanded' : ''}`}>
      <div className={`dd-device-hero${isDashboardExpanded ? ' is-hidden' : ''}`}>
        <DeviceDetailsHeroImage
          templateImage={template?.icon}
          deviceIcon={details.data.icon}
        />
      </div>

      <div className='details-remain-head'>
          <div
              className={`details-remain-head-part dd-head-part-top${isDashboardExpanded ? ' dd-head-part-top-expanded' : ''}`}
          >
              <div className='details-head-left'>
                <div className="dd-title-main">
                    <div className="dd-title-main-primary">
                      <h1 className="dd-device-title">
                          {details.data.name}
                      </h1>

                      {details.data.status && (
                        <div
                        className={'details-meta-status ' + (details.data.status === 'Online' ? 'dd-status-online' : 'dd-status-offline')}>
                                  <span
                                      className={'details-status-dot-small ' + (details.data.status === 'Online' ? 'dd-dot-online' : 'dd-dot-offline')} />
                                  <span>{details.data.status}</span>
                              </div>
                          )}
                          {worstStatus?.name && (
                              <button
                                  type="button"
                                  className="dd-status-clickable dd-status-inline"
                                  onClick={() => setShowStatusModal({ open: true })}
                                  title={L.pressToShowDetails}
                              >
                                  <StatusIndicator
                                      statusKey={worstStatus.key}
                                      displayName={worstStatus.name}
                                      t={L}
                                      color={worstStatus.color}
                                  />
                              </button>
                          )}
                    </div>

                    {isDashboardExpanded ? (
                        <div className="dd-title-main-controls">
                            {renderDeviceAssetCards()}
                            <div className="dd-head-inline-range">
                                {renderRangeControls()}
                            </div>
                            {renderExpandToggle('dd-expand-toggle-corner')}
                        </div>
                    ) : null}
                </div>

                  <div className={`details-head-meta-row dd-expandable-meta${isDashboardExpanded ? ' is-hidden' : ''}${moreMenuOpen ? ' dd-expandable-meta--menu-open' : ''}`}>
                      {details.data.organization_name ? (
                          <div
                              className={'details-meta-pill' + (permissions['edit_organizations'] ? ' is-clickable' : '')}
                              onClick={
                                  permissions['edit_organizations']
                                      ? () =>
                                            navigate(
                                                '/administration/organizations/details/' +
                                                    details.data.organization_id,
                                            )
                                      : undefined
                              }
                          >
                              <OrganizationIcon color={'var(--root-color)'} />
                              <span>{details.data.organization_name}</span>
                          </div>
                      ) : null}

                      {template?.id ? (
                          <div
                              className='details-meta-pill is-clickable dd-template-pill'
                              onClick={() => navigate(`/configuration/templates/details/${template.id}`)}
                              title={template.tid || template.name || ''}
                          >
                              <span className="dd-template-pill-label">
                                  {template.name || template.tid || 'Template'}
                              </span>
                          </div>
                      ) : null}

                      {details.data.owner_name ? (
                          <div
                              className={'details-meta-pill' + (permissions['edit_users'] ? ' is-clickable' : '')}
                              onClick={
                                  permissions['edit_users']
                                      ? () =>
                                            navigate(
                                                '/administration/users/details/' +
                                                    details.data.owner_id,
                                            )
                                      : undefined
                              }
                          >
                              <UsersIcons color={'var(--root-color)'} />
                              <span>{details.data.owner_name}</span>
                          </div>
                      ) : null}

                      {details.data.owner_name && details.data.status ? (
                          <span className="dd-meta-divider" style={{ display: 'inline-flex', alignItems: 'center', opacity: 0.55 }}>
                              <VerticalDividerIcon />
                          </span>
                      ) : null}

                      {canShowButtonGroup && (
                          <div
                              className="dd-head-eval-more"
                              style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: 10,
                                  marginRight: 12,
                              }}
                          >
                          <div
                              className="details-inline-more-wrapper dd-more-menu-wrapper"
                              ref={moreMenuRef}
                              style={{ display: 'inline-flex', alignItems: 'center' }}
                          >
                              {permissions['edit_devices'] ? (
                                  <Tooltip title={L.editDevice || 'Edit Device'}>
                                      <button
                                          type="button"
                                          className="details-inline-action-btn"
                                          onClick={(event) => {
                                              event.stopPropagation();
                                              setMoreMenuOpen(false);
                                              setEditDid({
                                                  open: true,
                                                  id: details.data.id,
                                                  row: {
                                                      id: details.data.id,
                                                      name: details.data.name,
                                                      did: details.data.did,
                                                  }
                                              });
                                          }}
                                      >
                                          <EditIcon style={{ color: "var(--details-icons-color, var(--sidenav-icons, #FFFFFF))" }} />
                                      </button>
                                  </Tooltip>
                              ) : null}

                              {canShowMoreMenuItems ? (
                                  <>
                                      <Tooltip title={L.more}>
                                          <button
                                              type="button"
                                              className="details-inline-action-btn dd-more-kebab-btn"
                                              onClick={() => setMoreMenuOpen((v) => !v)}
                                              aria-haspopup="menu"
                                              aria-expanded={moreMenuOpen ? 'true' : 'false'}
                                          >
                                              <MoreVertIcon style={{fill:'rgba(213, 213, 213, 0.56)'}}/>
                                          </button>
                                      </Tooltip>

                                      <div className={'details-actions-menu dd-actions-dropdown' + (moreMenuOpen ? ' open' : '')}>
                                  {canViewDeviceEvents && (
                                      <div
                                          className='details-actions-menu-item first'
                                          onClick={() => {
                                              setMoreMenuOpen(false);
                                              setDeviceEvents(true);
                                          }}
                                      >
                                          <NotificationsNoneIcon className="dd-notification-icon" />
                                          <span>{L.notificationsEvents}</span>
                                      </div>
                                  )}

                                  {permissions['view_devices'] && (
                                      <div
                                          className={'details-actions-menu-item' + (!canViewDeviceEvents ? ' first' : '')}
                                          onClick={() => {
                                              setMoreMenuOpen(false);
                                              navigate(`/devices/status-log/${details.data.id}`);
                                          }}
                                      >
                                          <HistoryIcon />
                                          <span>{L.viewStatusLog}</span>
                                      </div>
                                  )}

                                  {canOpenReportDialog && (
                                      <div
                                          className={'details-actions-menu-item' + (!canViewDeviceEvents && !permissions['view_devices'] ? ' first' : '')}
                                          onClick={() => {
                                              setMoreMenuOpen(false);
                                              setReport({
                                                  open: true,
                                                  id: details.data.id,
                                                  device: details,
                                              });
                                          }}
                                      >
                                          <DownloadReprtIcon />
                                          <span>{downloadReportActionLabel}</span>
                                      </div>
                                  )}

                                  {canShowActions ? (
                                      <>
                                          <div className="details-actions-menu-sep" />
                                          {actions.map((action, idx) => {
                                              const isDanger = String(action?.title || '').toLowerCase().startsWith('delete');
                                              const itemClassName = `details-actions-menu-item${isDanger ? ' danger' : ''}`;

                                              return (
                                                  <div
                                                      key={idx}
                                                      className={itemClassName}
                                                      onClick={() => {
                                                          setMoreMenuOpen(false);
                                                          const needsId = ['Delete', 'Transfer', 'Rename'].some((term) =>
                                                              String(action?.title || '').includes(term)
                                                          );

                                                          action.action(needsId ? details.data.id : details.data.did);
                                                      }}
                                                  >
                                                      {action.icon}
                                                      <span>{action.title}</span>
                                                  </div>
                                              );
                                          })}
                                      </>
                                  ) : null}
                                      </div>
                                  </>
                              ) : null}
                          </div>
                          </div>
                      )}

                  </div>
              </div>
          </div>

          {!isDashboardExpanded ? (
              <div className='details-remain-head-part dd-head-part-center'>
                  <div className="dd-head-actions-row">
                      {renderDeviceAssetCards()}
                      {renderRangeControls()}
                      {renderExpandToggle()}
                  </div>
              </div>
          ) : null}
  </div>
  </div>
  {template && template.webdashboard && template.webdashboard.length > 0 ?
                              <div ref={dashboardBodyRef} className={`details-body dd-details-body-dashboard${isDashboardExpanded ? ' dd-details-body-dashboard-expanded' : ''}`}>
                                      <div className={`dashboard-tabs-shell${isDashboardExpanded ? ' dd-dashboard-tabs-expanded' : ''}`}>
                                          <DashboardTabsArrow direction={-1} />
                                          <div className="dashboard-tabs dd-dashboard-tabs">
                                              {template.webdashboard.map((wd, idx) => (<div key={idx}
                                              className={`dashboard-tab dd-dashboard-tab-fixed ${currentDashboard === idx ? 'tab-active' : ''}`}
                                              title={wd.name}
                                              onClick={() => {
                                                  setCurrentDashboard(idx);
                                                  setSearchParams({ tab: idx }); 
                                              }}>
                                              <span>{wd.name}</span>
                                          </div>))}
                                          <div className='dashboard-tab-border'></div>
                                          </div>
                                          <DashboardTabsArrow direction={1} />
                                          {isDashboardExpanded ? (
                                              <div className='dd-dashboard-tabs-actions'>
                                                  {renderExpandToggle('dd-expand-toggle-tabs')}
                                              </div>
                                          ) : null}
                                      </div>
                                  <div ref={dashboardViewportRef} className='dd-dashboard-viewport'>
                                      <WebDashboard did={details.data.did} mode={'view'} tid={template.tid}
                                          datastreams={template.datastreams} maxWidth='100%' maxHeight={maxHeight}
                                          dashboard={template.webdashboard[currentDashboard]}
                                          setDashboard={(webDashboard) => setTemplate(prev => ({
                                              ...prev,
                                              webdashboard: prev.webdashboard.map(
                                                  (wd, ix) => ix === currentDashboard ? webDashboard : wd)
                                          }))} />
                                  </div>
                              </div> :
                              <div className='details-body dd-details-body-empty'>{L.noDataBody}</div>}
                      </div>
                  </div> : <div className="dd-no-data-center">{devTranslations[lang].noData}</div>
      );
  };  
